// Auto-generated: inlined SVG content for adult Blobbi assets.
// Source: src/blobbi/adult-blobbi/assets/

import type { AdultForm } from '../types/adult.types';

const BLOOMI_BASE = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <!-- Grupo das pétalas com rotação -->
  <g transform="rotate(0 100 110)">
    <animateTransform 
      attributeName="transform" 
      type="rotate" 
      from="0 100 110" 
      to="360 100 110" 
      dur="10s" 
      repeatCount="indefinite" />
    <circle cx="100" cy="70" r="25" fill="url(#bloomiPetal1)" />
    <circle cx="130" cy="90" r="25" fill="url(#bloomiPetal2)" />
    <circle cx="130" cy="130" r="25" fill="url(#bloomiPetal3)" />
    <circle cx="100" cy="150" r="25" fill="url(#bloomiPetal4)" />
    <circle cx="70" cy="130" r="25" fill="url(#bloomiPetal5)" />
    <circle cx="70" cy="90" r="25" fill="url(#bloomiPetal6)" />
  </g>

  <!-- Grupo das partículas giratórias -->
  <g transform="rotate(0 100 110)">
    <animateTransform 
      attributeName="transform" 
      type="rotate" 
      from="0 100 110" 
      to="-360 100 110" 
      dur="20s" 
      repeatCount="indefinite" />
    <circle cx="60" cy="80" r="2" fill="url(#bloomiPollen)" opacity="0.8" />
    <circle cx="140" cy="85" r="1.5" fill="url(#bloomiPollen)" opacity="0.6" />
    <circle cx="55" cy="140" r="1" fill="url(#bloomiPollen)" opacity="0.7" />
    <circle cx="145" cy="135" r="2" fill="url(#bloomiPollen)" opacity="0.5" />
    <circle cx="75" cy="60" r="1.5" fill="url(#bloomiPollen)" opacity="0.9" />
  </g>

  <!-- Centro da flor -->
  <circle cx="100" cy="110" r="35" fill="url(#bloomiCenter)" data-blobbi-body="true" />
  <circle cx="100" cy="110" r="28" fill="url(#bloomiCenterHighlight)" opacity="0.6" />

  <!-- Eyes (white/base eye shapes) -->
  <circle cx="88" cy="105" r="8" fill="white" />
  <circle cx="112" cy="105" r="8" fill="white" />
  
  <!-- Pupils (pupil + highlights) -->
  <circle cx="88" cy="105" r="5" fill="#1f2937" />
  <circle cx="112" cy="105" r="5" fill="#1f2937" />
  <circle cx="90" cy="103" r="2" fill="white" />
  <circle cx="114" cy="103" r="2" fill="white" />

  <!-- Mouth -->
  <path d="M 90 120 Q 100 128 110 120" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />

  <!-- Bochechas -->
  <circle cx="70" cy="115" r="8" fill="url(#bloomiBlush)" opacity="0.6" />
  <circle cx="130" cy="115" r="8" fill="url(#bloomiBlush)" opacity="0.6" />

  <!-- Gradientes -->
  <defs>
    <radialGradient id="bloomiPetal1" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#fef3c7" />
      <stop offset="100%" stop-color="#fbbf24" />
    </radialGradient>
    <radialGradient id="bloomiPetal2" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#fed7d7" />
      <stop offset="100%" stop-color="#f87171" />
    </radialGradient>
    <radialGradient id="bloomiPetal3" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#fce7f3" />
      <stop offset="100%" stop-color="#f472b6" />
    </radialGradient>
    <radialGradient id="bloomiPetal4" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#e0e7ff" />
      <stop offset="100%" stop-color="#8b5cf6" />
    </radialGradient>
    <radialGradient id="bloomiPetal5" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#dcfce7" />
      <stop offset="100%" stop-color="#22c55e" />
    </radialGradient>
    <radialGradient id="bloomiPetal6" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#dbeafe" />
      <stop offset="100%" stop-color="#3b82f6" />
    </radialGradient>
    <radialGradient id="bloomiCenter" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#fef3c7" />
      <stop offset="50%" stop-color="#fbbf24" />
      <stop offset="100%" stop-color="#f59e0b" />
    </radialGradient>
    <radialGradient id="bloomiCenterHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#ffffff" />
      <stop offset="100%" stop-color="rgba(255,255,255,0.3)" />
    </radialGradient>
    <radialGradient id="bloomiBlush" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#fce7f3" />
      <stop offset="100%" stop-color="#f472b6" />
    </radialGradient>
    <radialGradient id="bloomiPollen" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#fef3c7" />
      <stop offset="100%" stop-color="#fbbf24" />
    </radialGradient>
  </defs>
</svg>`;

const BLOOMI_SLEEPING = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <!-- Grupo das pétalas com rotação mais lenta (ou pode ser removido completamente) -->
  <g transform="rotate(0 100 110)">
    <animateTransform 
      attributeName="transform" 
      type="rotate" 
      from="0 100 110" 
      to="360 100 110" 
      dur="20s" 
      repeatCount="indefinite" />
    <circle cx="100" cy="70" r="25" fill="url(#bloomiPetal1)" />
    <circle cx="130" cy="90" r="25" fill="url(#bloomiPetal2)" />
    <circle cx="130" cy="130" r="25" fill="url(#bloomiPetal3)" />
    <circle cx="100" cy="150" r="25" fill="url(#bloomiPetal4)" />
    <circle cx="70" cy="130" r="25" fill="url(#bloomiPetal5)" />
    <circle cx="70" cy="90" r="25" fill="url(#bloomiPetal6)" />
  </g>

  <!-- Grupo das partículas giratórias -->
  <g transform="rotate(0 100 110)">
    <animateTransform 
      attributeName="transform" 
      type="rotate" 
      from="0 100 110" 
      to="-360 100 110" 
      dur="30s" 
      repeatCount="indefinite" />
    <circle cx="60" cy="80" r="2" fill="url(#bloomiPollen)" opacity="0.4" />
    <circle cx="140" cy="85" r="1.5" fill="url(#bloomiPollen)" opacity="0.3" />
    <circle cx="55" cy="140" r="1" fill="url(#bloomiPollen)" opacity="0.3" />
    <circle cx="145" cy="135" r="2" fill="url(#bloomiPollen)" opacity="0.2" />
    <circle cx="75" cy="60" r="1.5" fill="url(#bloomiPollen)" opacity="0.4" />
  </g>

  <!-- Centro da flor -->
  <circle cx="100" cy="110" r="35" fill="url(#bloomiCenter)" data-blobbi-body="true" />
  <circle cx="100" cy="110" r="28" fill="url(#bloomiCenterHighlight)" opacity="0.6" />

  <!-- Olhos dormindo -->
  <path d="M 80 105 Q 88 108 96 105" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  <path d="M 104 105 Q 112 108 120 105" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />

  <!-- Boca calma -->
  <circle cx="100" cy="120" r="2" fill="#1f2937" />

  <!-- Bochechas -->
  <circle cx="70" cy="115" r="8" fill="url(#bloomiBlush)" opacity="0.6" />
  <circle cx="130" cy="115" r="8" fill="url(#bloomiBlush)" opacity="0.6" />

  <!-- "Zzz" dormindo -->
  <text x="150" y="60" font-size="10" fill="#666" opacity="0.8">Z</text>
  <text x="157" y="55" font-size="8" fill="#666" opacity="0.6">z</text>
  <text x="162" y="51" font-size="6" fill="#666" opacity="0.4">z</text>

  <!-- Gradientes -->
  <defs>
    <radialGradient id="bloomiPetal1" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#fef3c7" />
      <stop offset="100%" stop-color="#fbbf24" />
    </radialGradient>
    <radialGradient id="bloomiPetal2" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#fed7d7" />
      <stop offset="100%" stop-color="#f87171" />
    </radialGradient>
    <radialGradient id="bloomiPetal3" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#fce7f3" />
      <stop offset="100%" stop-color="#f472b6" />
    </radialGradient>
    <radialGradient id="bloomiPetal4" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#e0e7ff" />
      <stop offset="100%" stop-color="#8b5cf6" />
    </radialGradient>
    <radialGradient id="bloomiPetal5" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#dcfce7" />
      <stop offset="100%" stop-color="#22c55e" />
    </radialGradient>
    <radialGradient id="bloomiPetal6" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#dbeafe" />
      <stop offset="100%" stop-color="#3b82f6" />
    </radialGradient>
    <radialGradient id="bloomiCenter" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#fef3c7" />
      <stop offset="50%" stop-color="#fbbf24" />
      <stop offset="100%" stop-color="#f59e0b" />
    </radialGradient>
    <radialGradient id="bloomiCenterHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#ffffff" />
      <stop offset="100%" stop-color="rgba(255,255,255,0.3)" />
    </radialGradient>
    <radialGradient id="bloomiBlush" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#fce7f3" />
      <stop offset="100%" stop-color="#f472b6" />
    </radialGradient>
    <radialGradient id="bloomiPollen" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#fef3c7" />
      <stop offset="100%" stop-color="#fbbf24" />
    </radialGradient>
  </defs>
</svg>
`;

const BREEZY_BASE = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">  
  <!-- Main leaf body - classic leaf shape -->
  <path d="M 100 40 Q 70 60 60 90 Q 55 120 70 140 Q 85 155 100 160 Q 115 155 130 140 Q 145 120 140 90 Q 130 60 100 40" 
        fill="url(#breezyBody)" data-blobbi-body="true" />
  
  <!-- Leaf veins - central vein -->
  <path d="M 100 45 L 100 155" stroke="url(#breezyVein)" stroke-width="3" opacity="0.6" />
  
  <!-- Side veins -->
  <path d="M 100 70 L 80 85" stroke="url(#breezyVein)" stroke-width="2" opacity="0.5" />
  <path d="M 100 70 L 120 85" stroke="url(#breezyVein)" stroke-width="2" opacity="0.5" />
  <path d="M 100 100 L 75 115" stroke="url(#breezyVein)" stroke-width="2" opacity="0.5" />
  <path d="M 100 100 L 125 115" stroke="url(#breezyVein)" stroke-width="2" opacity="0.5" />
  <path d="M 100 130 L 85 140" stroke="url(#breezyVein)" stroke-width="2" opacity="0.5" />
  <path d="M 100 130 L 115 140" stroke="url(#breezyVein)" stroke-width="2" opacity="0.5" />
  
  <!-- Inner leaf highlight -->
  <path d="M 100 50 Q 75 65 68 85 Q 65 105 75 120 Q 85 130 100 135 Q 115 130 125 120 Q 135 105 132 85 Q 125 65 100 50" 
        fill="url(#breezyInner)" opacity="0.6" />
  
  <!-- Eyes (white base) -->
  <circle cx="85" cy="90" r="10" fill="white" />
  <circle cx="115" cy="90" r="10" fill="white" />
  
  <!-- Pupils (dark circles + highlights) -->
  <circle cx="85" cy="90" r="6" fill="#1f2937" />
  <circle cx="115" cy="90" r="6" fill="#1f2937" />
  <circle cx="87" cy="88" r="3" fill="white" />
  <circle cx="117" cy="88" r="3" fill="white" />
  
  <!-- Mouth -->
  <path d="M 85 110 Q 100 120 115 110" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Little arms -->
  <path d="M 65 100 Q 55 95 50 105 Q 55 115 65 110" fill="url(#breezyArm)" />
  <path d="M 135 100 Q 145 95 150 105 Q 145 115 135 110" fill="url(#breezyArm)" />
  
  <!-- Little legs -->
  <ellipse cx="90" cy="155" rx="10" ry="8" fill="url(#breezyLeg)" />
  <ellipse cx="110" cy="155" rx="10" ry="8" fill="url(#breezyLeg)" />
  
  <!-- Floating leaves with rotation groups -->
  <g transform="translate(100 100)">
    <g>
      <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="8s" repeatCount="indefinite" />
      <path d="M -50 -30 Q -55 -25 -50 -20 Q -45 -25 -50 -30" fill="url(#breezyFloating)" opacity="0.8" />
    </g>
  </g>

  <g transform="translate(100 100)">
    <g>
      <animateTransform attributeName="transform" type="rotate" from="0" to="-360" dur="9s" repeatCount="indefinite" />
      <path d="M 50 -25 Q 45 -20 50 -15 Q 55 -20 50 -25" fill="url(#breezyFloating)" opacity="0.6" />
    </g>
  </g>

  <g transform="translate(100 100)">
    <g>
      <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="7s" repeatCount="indefinite" />
      <path d="M -55 30 Q -60 35 -55 40 Q -50 35 -55 30" fill="url(#breezyFloating)" opacity="0.7" />
    </g>
  </g>

  <g transform="translate(100 100)">
    <g>
      <animateTransform attributeName="transform" type="rotate" from="0" to="-360" dur="10s" repeatCount="indefinite" />
      <path d="M 55 25 Q 50 30 55 35 Q 60 30 55 25" fill="url(#breezyFloating)" opacity="0.5" />
    </g>
  </g>
  
  <defs>
    <radialGradient id="breezyBody" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#86efac" />
      <stop offset="30%" stop-color="#4ade80" />
      <stop offset="70%" stop-color="#22c55e" />
      <stop offset="100%" stop-color="#16a34a" />
    </radialGradient>
    <radialGradient id="breezyInner" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#bbf7d0" />
      <stop offset="100%" stop-color="#86efac" />
    </radialGradient>
    <linearGradient id="breezyVein" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="#15803d" />
      <stop offset="50%" stop-color="#16a34a" />
      <stop offset="100%" stop-color="#15803d" />
    </linearGradient>
    <radialGradient id="breezyArm" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#4ade80" />
      <stop offset="100%" stop-color="#16a34a" />
    </radialGradient>
    <radialGradient id="breezyLeg" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#22c55e" />
      <stop offset="100%" stop-color="#15803d" />
    </radialGradient>
    <radialGradient id="breezyFloating" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#86efac" />
      <stop offset="100%" stop-color="#22c55e" />
    </radialGradient>
  </defs>
</svg>`;

const BREEZY_SLEEPING = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">  
  <!-- Main leaf body -->
  <path d="M 100 40 Q 70 60 60 90 Q 55 120 70 140 Q 85 155 100 160 Q 115 155 130 140 Q 145 120 140 90 Q 130 60 100 40" 
        fill="url(#breezyBody)" data-blobbi-body="true" />
  
  <!-- Leaf veins -->
  <path d="M 100 45 L 100 155" stroke="url(#breezyVein)" stroke-width="3" opacity="0.6" />
  <path d="M 100 70 L 80 85" stroke="url(#breezyVein)" stroke-width="2" opacity="0.5" />
  <path d="M 100 70 L 120 85" stroke="url(#breezyVein)" stroke-width="2" opacity="0.5" />
  <path d="M 100 100 L 75 115" stroke="url(#breezyVein)" stroke-width="2" opacity="0.5" />
  <path d="M 100 100 L 125 115" stroke="url(#breezyVein)" stroke-width="2" opacity="0.5" />
  <path d="M 100 130 L 85 140" stroke="url(#breezyVein)" stroke-width="2" opacity="0.5" />
  <path d="M 100 130 L 115 140" stroke="url(#breezyVein)" stroke-width="2" opacity="0.5" />
  
  <!-- Inner leaf highlight -->
  <path d="M 100 50 Q 75 65 68 85 Q 65 105 75 120 Q 85 130 100 135 Q 115 130 125 120 Q 135 105 132 85 Q 125 65 100 50" 
        fill="url(#breezyInner)" opacity="0.6" />

  <!-- Olhos dormindo -->
  <path d="M 75 90 Q 85 93 95 90" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  <path d="M 105 90 Q 115 93 125 90" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />

  <!-- Boca tranquila -->
  <circle cx="100" cy="110" r="2" fill="#1f2937" />

  <!-- Little arms -->
  <path d="M 65 100 Q 55 95 50 105 Q 55 115 65 110" fill="url(#breezyArm)" />
  <path d="M 135 100 Q 145 95 150 105 Q 145 115 135 110" fill="url(#breezyArm)" />

  <!-- Little legs -->
  <ellipse cx="90" cy="155" rx="10" ry="8" fill="url(#breezyLeg)" />
  <ellipse cx="110" cy="155" rx="10" ry="8" fill="url(#breezyLeg)" />

  <!-- Floating leaves -->
  <g transform="translate(100 100)">
    <g>
      <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="8s" repeatCount="indefinite" />
      <path d="M -50 -30 Q -55 -25 -50 -20 Q -45 -25 -50 -30" fill="url(#breezyFloating)" opacity="0.6" />
    </g>
  </g>
  <g transform="translate(100 100)">
    <g>
      <animateTransform attributeName="transform" type="rotate" from="0" to="-360" dur="9s" repeatCount="indefinite" />
      <path d="M 50 -25 Q 45 -20 50 -15 Q 55 -20 50 -25" fill="url(#breezyFloating)" opacity="0.5" />
    </g>
  </g>
  <g transform="translate(100 100)">
    <g>
      <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="7s" repeatCount="indefinite" />
      <path d="M -55 30 Q -60 35 -55 40 Q -50 35 -55 30" fill="url(#breezyFloating)" opacity="0.5" />
    </g>
  </g>
  <g transform="translate(100 100)">
    <g>
      <animateTransform attributeName="transform" type="rotate" from="0" to="-360" dur="10s" repeatCount="indefinite" />
      <path d="M 55 25 Q 50 30 55 35 Q 60 30 55 25" fill="url(#breezyFloating)" opacity="0.4" />
    </g>
  </g>

  <!-- "Zzz" dormindo -->
  <text x="150" y="60" font-size="10" fill="#666" opacity="0.8">Z</text>
  <text x="157" y="55" font-size="8" fill="#666" opacity="0.6">z</text>
  <text x="162" y="51" font-size="6" fill="#666" opacity="0.4">z</text>

  <!-- Gradientes -->
  <defs>
    <radialGradient id="breezyBody" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#86efac" />
      <stop offset="30%" stop-color="#4ade80" />
      <stop offset="70%" stop-color="#22c55e" />
      <stop offset="100%" stop-color="#16a34a" />
    </radialGradient>
    <radialGradient id="breezyInner" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#bbf7d0" />
      <stop offset="100%" stop-color="#86efac" />
    </radialGradient>
    <linearGradient id="breezyVein" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="#15803d" />
      <stop offset="50%" stop-color="#16a34a" />
      <stop offset="100%" stop-color="#15803d" />
    </linearGradient>
    <radialGradient id="breezyArm" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#4ade80" />
      <stop offset="100%" stop-color="#16a34a" />
    </radialGradient>
    <radialGradient id="breezyLeg" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#22c55e" />
      <stop offset="100%" stop-color="#15803d" />
    </radialGradient>
    <radialGradient id="breezyFloating" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#86efac" />
      <stop offset="100%" stop-color="#22c55e" />
    </radialGradient>
  </defs>
</svg>
`;

const CACTI_BASE = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  
  <!-- Main cactus body -->
  <rect x="85" y="80" width="30" height="80" rx="15" fill="url(#cactiBody)" data-blobbi-body="true" />
  
  <!-- Cactus arms -->
  <rect x="60" y="100" width="20" height="40" rx="10" fill="url(#cactiArm)" />
  <rect x="120" y="110" width="20" height="35" rx="10" fill="url(#cactiArm)" />
  
  <!-- Cactus ridges -->
  <line x1="92" y1="85" x2="92" y2="155" stroke="#65a30d" stroke-width="2" opacity="0.5" />
  <line x1="100" y1="85" x2="100" y2="155" stroke="#65a30d" stroke-width="2" opacity="0.5" />
  <line x1="108" y1="85" x2="108" y2="155" stroke="#65a30d" stroke-width="2" opacity="0.5" />
  
  <!-- Eyes (white base) -->
  <circle cx="90" cy="105" r="8" fill="white" />
  <circle cx="110" cy="105" r="8" fill="white" />
  
  <!-- Pupils (dark circles + highlights) -->
  <circle cx="90" cy="105" r="5" fill="#1f2937" />
  <circle cx="110" cy="105" r="5" fill="#1f2937" />
  <circle cx="92" cy="103" r="2" fill="white" />
  <circle cx="112" cy="103" r="2" fill="white" />
  
  <!-- Mouth -->
  <path d="M 92 120 Q 100 126 108 120" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Tiny spines -->
  <circle cx="88" cy="90" r="1" fill="#65a30d" />
  <circle cx="95" cy="95" r="1" fill="#65a30d" />
  <circle cx="105" cy="92" r="1" fill="#65a30d" />
  <circle cx="112" cy="88" r="1" fill="#65a30d" />
  <circle cx="65" cy="110" r="1" fill="#65a30d" />
  <circle cx="70" cy="120" r="1" fill="#65a30d" />
  <circle cx="125" cy="115" r="1" fill="#65a30d" />
  <circle cx="130" cy="125" r="1" fill="#65a30d" />
  
  <!-- Little legs in pot -->
  <path d="M 75 160 L 80 175 L 120 175 L 125 160 Z" fill="url(#cactiPot)" />
  <rect x="75" y="160" width="50" height="5" fill="url(#cactiPotRim)" rx="2" />
  
  <!-- Blooming flower -->
  <circle cx="100" cy="75" r="12" fill="url(#cactiFlower)" />
  <circle cx="100" cy="75" r="8" fill="url(#cactiFlowerCenter)" />
  <circle cx="100" cy="75" r="4" fill="#fbbf24" />
  
  <defs>
    <radialGradient id="cactiBody" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#a3e635" />
      <stop offset="30%" stop-color="#84cc16" />
      <stop offset="70%" stop-color="#65a30d" />
      <stop offset="100%" stop-color="#4d7c0f" />
    </radialGradient>
    <radialGradient id="cactiArm" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#84cc16" />
      <stop offset="100%" stop-color="#65a30d" />
    </radialGradient>
    <radialGradient id="cactiPot" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#dc2626" />
      <stop offset="100%" stop-color="#991b1b" />
    </radialGradient>
    <radialGradient id="cactiPotRim" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#ef4444" />
      <stop offset="100%" stop-color="#dc2626" />
    </radialGradient>
    <radialGradient id="cactiFlower" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#fce7f3" />
      <stop offset="100%" stop-color="#f472b6" />
    </radialGradient>
    <radialGradient id="cactiFlowerCenter" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#fef3c7" />
      <stop offset="100%" stop-color="#fbbf24" />
    </radialGradient>
  </defs>
</svg>`;

const CACTI_SLEEPING = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  
  <!-- Main cactus body -->
  <rect x="85" y="80" width="30" height="80" rx="15" fill="url(#cactiBody)" data-blobbi-body="true" />
  
  <!-- Cactus arms -->
  <rect x="60" y="100" width="20" height="40" rx="10" fill="url(#cactiArm)" />
  <rect x="120" y="110" width="20" height="35" rx="10" fill="url(#cactiArm)" />
  
  <!-- Cactus ridges -->
  <line x1="92" y1="85" x2="92" y2="155" stroke="#65a30d" stroke-width="2" opacity="0.5" />
  <line x1="100" y1="85" x2="100" y2="155" stroke="#65a30d" stroke-width="2" opacity="0.5" />
  <line x1="108" y1="85" x2="108" y2="155" stroke="#65a30d" stroke-width="2" opacity="0.5" />
  
  <!-- Sleeping eyes -->
  <path d="M 82 105 Q 90 108 98 105" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  <path d="M 102 105 Q 110 108 118 105" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Peaceful mouth -->
  <circle cx="100" cy="120" r="2" fill="#1f2937" />
  
  <!-- Tiny spines -->
  <circle cx="88" cy="90" r="1" fill="#65a30d" />
  <circle cx="95" cy="95" r="1" fill="#65a30d" />
  <circle cx="105" cy="92" r="1" fill="#65a30d" />
  <circle cx="112" cy="88" r="1" fill="#65a30d" />
  <circle cx="65" cy="110" r="1" fill="#65a30d" />
  <circle cx="70" cy="120" r="1" fill="#65a30d" />
  <circle cx="125" cy="115" r="1" fill="#65a30d" />
  <circle cx="130" cy="125" r="1" fill="#65a30d" />
  
  <!-- Little legs in pot -->
  <path d="M 75 160 L 80 175 L 120 175 L 125 160 Z" fill="url(#cactiPot)" />
  <rect x="75" y="160" width="50" height="5" fill="url(#cactiPotRim)" rx="2" />
  
  <!-- Blooming flower -->
  <circle cx="100" cy="75" r="12" fill="url(#cactiFlower)" />
  <circle cx="100" cy="75" r="8" fill="url(#cactiFlowerCenter)" />
  <circle cx="100" cy="75" r="4" fill="#fbbf24" />

  <!-- "Zzz" sleeping -->
  <text x="150" y="60" font-size="10" fill="#666" opacity="0.8">Z</text>
  <text x="157" y="55" font-size="8" fill="#666" opacity="0.6">z</text>
  <text x="162" y="51" font-size="6" fill="#666" opacity="0.4">z</text>
  
  <defs>
    <radialGradient id="cactiBody" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#a3e635" />
      <stop offset="30%" stop-color="#84cc16" />
      <stop offset="70%" stop-color="#65a30d" />
      <stop offset="100%" stop-color="#4d7c0f" />
    </radialGradient>
    <radialGradient id="cactiArm" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#84cc16" />
      <stop offset="100%" stop-color="#65a30d" />
    </radialGradient>
    <radialGradient id="cactiPot" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#dc2626" />
      <stop offset="100%" stop-color="#991b1b" />
    </radialGradient>
    <radialGradient id="cactiPotRim" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#ef4444" />
      <stop offset="100%" stop-color="#dc2626" />
    </radialGradient>
    <radialGradient id="cactiFlower" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#fce7f3" />
      <stop offset="100%" stop-color="#f472b6" />
    </radialGradient>
    <radialGradient id="cactiFlowerCenter" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#fef3c7" />
      <stop offset="100%" stop-color="#fbbf24" />
    </radialGradient>
  </defs>
</svg>`;

const CATTI_BASE = `<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Gradients for 3D effect -->
    <radialGradient id="cattiBody3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#fed7aa;stop-opacity:1" />
      <stop offset="40%" style="stop-color:#f97316;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#c2410c;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="cattiEar3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#f97316;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#c2410c;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="cattiEarInner" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#f59e0b;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="cattiEyeWhite3D" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#f3f4f6;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="cattiPupil3D" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#374151;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#1f2937;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="cattiNose3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#f472b6;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#be185d;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="cattiNoseHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#fce7f3;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#f472b6;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="cattiTail3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#fed7aa;stop-opacity:1" />
      <stop offset="50%" style="stop-color:#f97316;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#c2410c;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="cattiTailHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#fef3c7;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#fed7aa;stop-opacity:1" />
    </radialGradient>
    <linearGradient id="cattiMouth3D" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" style="stop-color:#374151;stop-opacity:1" />
      <stop offset="50%" style="stop-color:#1f2937;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#374151;stop-opacity:1" />
    </linearGradient>
  </defs>
  
  <!-- Oval upright body -->
  <ellipse cx="100" cy="120" rx="45" ry="60" fill="url(#cattiBody3D)" data-blobbi-body="true" />
  
  <!-- Triangle ears -->
  <path d="M 68 72 L 58 48 L 82 62 Z" fill="url(#cattiEar3D)" />
  <path d="M 132 72 L 142 48 L 118 62 Z" fill="url(#cattiEar3D)" />
  <path d="M 70 62 L 64 52 L 76 58 Z" fill="url(#cattiEarInner)" />
  <path d="M 130 62 L 136 52 L 124 58 Z" fill="url(#cattiEarInner)" />
  
  <!-- Eyes (white/base eye shapes) -->
  <ellipse cx="85" cy="100" rx="12" ry="16" fill="url(#cattiEyeWhite3D)" />
  <ellipse cx="115" cy="100" rx="12" ry="16" fill="url(#cattiEyeWhite3D)" />
  
  <!-- Pupils (pupil + highlights) -->
  <ellipse cx="85" cy="100" rx="8" ry="12" fill="url(#cattiPupil3D)" />
  <ellipse cx="115" cy="100" rx="8" ry="12" fill="url(#cattiPupil3D)" />
  <ellipse cx="87" cy="97" rx="3" ry="4" fill="white" opacity="0.9" />
  <ellipse cx="117" cy="97" rx="3" ry="4" fill="white" opacity="0.9" />
  
  <!-- Nose -->
  <path d="M 94 115 L 100 122 L 106 115 Z" fill="url(#cattiNose3D)" />
  <path d="M 96 116 L 100 120 L 104 116 Z" fill="url(#cattiNoseHighlight)" />
  
  <!-- Mouth -->
  <path d="M 100 122 Q 88 128 82 122" stroke="url(#cattiMouth3D)" stroke-width="2.5" fill="none" stroke-linecap="round" />
  <path d="M 100 122 Q 112 128 118 122" stroke="url(#cattiMouth3D)" stroke-width="2.5" fill="none" stroke-linecap="round" />
  
  <!-- Enhanced curved tail -->
  <path d="M 145 140 Q 165 115 158 95 Q 148 75 165 65" stroke="url(#cattiTail3D)" stroke-width="22" fill="none" stroke-linecap="round" />
  <path d="M 145 140 Q 163 117 156 97 Q 148 79 163 69" stroke="url(#cattiTailHighlight)" stroke-width="16" fill="none" stroke-linecap="round" />
  
  <!-- Enhanced whiskers -->
  <path d="M 48 108 Q 58 110 72 108" stroke="#1e293b" stroke-width="1.8" fill="none" stroke-linecap="round" />
  <path d="M 48 118 Q 58 120 72 118" stroke="#1e293b" stroke-width="1.8" fill="none" stroke-linecap="round" />
  <path d="M 128 108 Q 138 110 152 108" stroke="#1e293b" stroke-width="1.8" fill="none" stroke-linecap="round" />
  <path d="M 128 118 Q 138 120 152 118" stroke="#1e293b" stroke-width="1.8" fill="none" stroke-linecap="round" />
  
  <!-- Soft fur texture details -->
  <ellipse cx="75" cy="135" rx="3" ry="2" fill="rgba(255,255,255,0.2)" />
  <ellipse cx="125" cy="130" rx="2.5" ry="2" fill="rgba(255,255,255,0.2)" />
  <ellipse cx="90" cy="150" rx="2" ry="1.5" fill="rgba(255,255,255,0.15)" />
</svg>`;

const CATTI_SLEEPING = `<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Gradients for 3D effect -->
    <radialGradient id="cattiBody3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#fed7aa;stop-opacity:1" />
      <stop offset="40%" style="stop-color:#f97316;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#c2410c;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="cattiEar3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#f97316;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#c2410c;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="cattiEarInner" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#f59e0b;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="cattiEyeWhite3D" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#f3f4f6;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="cattiPupil3D" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#374151;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#1f2937;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="cattiNose3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#f472b6;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#be185d;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="cattiNoseHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#fce7f3;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#f472b6;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="cattiTail3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#fed7aa;stop-opacity:1" />
      <stop offset="50%" style="stop-color:#f97316;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#c2410c;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="cattiTailHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#fef3c7;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#fed7aa;stop-opacity:1" />
    </radialGradient>
    <linearGradient id="cattiMouth3D" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" style="stop-color:#374151;stop-opacity:1" />
      <stop offset="50%" style="stop-color:#1f2937;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#374151;stop-opacity:1" />
    </linearGradient>
  </defs>
  
  <!-- Oval upright body -->
  <ellipse cx="100" cy="120" rx="45" ry="60" fill="url(#cattiBody3D)" data-blobbi-body="true" />
  
  <!-- Triangle ears -->
  <path d="M 68 72 L 58 48 L 82 62 Z" fill="url(#cattiEar3D)" />
  <path d="M 132 72 L 142 48 L 118 62 Z" fill="url(#cattiEar3D)" />
  <path d="M 70 62 L 64 52 L 76 58 Z" fill="url(#cattiEarInner)" />
  <path d="M 130 62 L 136 52 L 124 58 Z" fill="url(#cattiEarInner)" />
  
  <!-- Sleeping eyes -->
  <path d="M 73 100 Q 85 103 97 100" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  <path d="M 103 100 Q 115 103 127 100" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Enhanced cat nose -->
  <path d="M 94 115 L 100 122 L 106 115 Z" fill="url(#cattiNose3D)" />
  <path d="M 96 116 L 100 120 L 104 116 Z" fill="url(#cattiNoseHighlight)" />
  
  <!-- Peaceful mouth -->
  <circle cx="100" cy="125" r="2" fill="#1f2937" />
  
  <!-- Enhanced curved tail -->
  <path d="M 145 140 Q 165 115 158 95 Q 148 75 165 65" stroke="url(#cattiTail3D)" stroke-width="22" fill="none" stroke-linecap="round" />
  <path d="M 145 140 Q 163 117 156 97 Q 148 79 163 69" stroke="url(#cattiTailHighlight)" stroke-width="16" fill="none" stroke-linecap="round" />
  
  <!-- Enhanced whiskers -->
  <path d="M 48 108 Q 58 110 72 108" stroke="#1e293b" stroke-width="1.8" fill="none" stroke-linecap="round" />
  <path d="M 48 118 Q 58 120 72 118" stroke="#1e293b" stroke-width="1.8" fill="none" stroke-linecap="round" />
  <path d="M 128 108 Q 138 110 152 108" stroke="#1e293b" stroke-width="1.8" fill="none" stroke-linecap="round" />
  <path d="M 128 118 Q 138 120 152 118" stroke="#1e293b" stroke-width="1.8" fill="none" stroke-linecap="round" />
  
  <!-- Soft fur texture details -->
  <ellipse cx="75" cy="135" rx="3" ry="2" fill="rgba(255,255,255,0.2)" />
  <ellipse cx="125" cy="130" rx="2.5" ry="2" fill="rgba(255,255,255,0.2)" />
  <ellipse cx="90" cy="150" rx="2" ry="1.5" fill="rgba(255,255,255,0.15)" />

  <!-- "Zzz" sleeping -->
  <text x="150" y="60" font-size="10" fill="#666" opacity="0.8">Z</text>
  <text x="157" y="55" font-size="8" fill="#666" opacity="0.6">z</text>
  <text x="162" y="51" font-size="6" fill="#666" opacity="0.4">z</text>
</svg>`;

const CLOUDI_BASE = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">  
  <!-- Main cloud body - multiple overlapping circles -->
  <circle cx="100" cy="120" r="45" fill="url(#cloudiBody)" data-blobbi-body="true" />
  <circle cx="75" cy="110" r="35" fill="url(#cloudiBody)" />
  <circle cx="125" cy="110" r="35" fill="url(#cloudiBody)" />
  <circle cx="85" cy="95" r="25" fill="url(#cloudiBody)" />
  <circle cx="115" cy="95" r="25" fill="url(#cloudiBody)" />
  <circle cx="100" cy="85" r="30" fill="url(#cloudiBody)" />
  
  <!-- Fluffy highlights -->
  <circle cx="90" cy="100" r="20" fill="url(#cloudiHighlight)" opacity="0.6" />
  <circle cx="110" cy="105" r="18" fill="url(#cloudiHighlight)" opacity="0.5" />
  <circle cx="100" cy="90" r="15" fill="url(#cloudiHighlight)" opacity="0.7" />
  
  <!-- Eyes (white/base eye shapes) -->
  <circle cx="88" cy="100" r="8" fill="white" />
  <circle cx="112" cy="100" r="8" fill="white" />
  
  <!-- Pupils (pupil + highlights) -->
  <circle cx="88" cy="100" r="5" fill="#64748b" />
  <circle cx="112" cy="100" r="5" fill="#64748b" />
  <circle cx="90" cy="98" r="2" fill="white" />
  <circle cx="114" cy="98" r="2" fill="white" />
  
  <!-- Mouth -->
  <path d="M 92 115 Q 100 122 108 115" stroke="#64748b" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Floating raindrops -->
  <circle cx="70" cy="140" r="3" fill="url(#cloudiRain)" opacity="0.8" />
  <circle cx="130" cy="145" r="2.5" fill="url(#cloudiRain)" opacity="0.6" />
  <circle cx="85" cy="155" r="2" fill="url(#cloudiRain)" opacity="0.7" />
  <circle cx="115" cy="150" r="2.5" fill="url(#cloudiRain)" opacity="0.5" />
  
  <defs>
    <radialGradient id="cloudiBody" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#ffffff" />
      <stop offset="50%" stop-color="#f1f5f9" />
      <stop offset="100%" stop-color="#e2e8f0" />
    </radialGradient>
    <radialGradient id="cloudiHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#ffffff" />
      <stop offset="100%" stop-color="rgba(255,255,255,0.5)" />
    </radialGradient>
    <radialGradient id="cloudiRain" cx="0.5" cy="0.3">
      <stop offset="0%" stop-color="#60a5fa" />
      <stop offset="100%" stop-color="#3b82f6" />
    </radialGradient>
  </defs>
</svg>`;

const CLOUDI_SLEEPING = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">  
  <!-- Main cloud body - multiple overlapping circles -->
  <circle cx="100" cy="120" r="45" fill="url(#cloudiBody)" data-blobbi-body="true" />
  <circle cx="75" cy="110" r="35" fill="url(#cloudiBody)" />
  <circle cx="125" cy="110" r="35" fill="url(#cloudiBody)" />
  <circle cx="85" cy="95" r="25" fill="url(#cloudiBody)" />
  <circle cx="115" cy="95" r="25" fill="url(#cloudiBody)" />
  <circle cx="100" cy="85" r="30" fill="url(#cloudiBody)" />
  
  <!-- Fluffy highlights -->
  <circle cx="90" cy="100" r="20" fill="url(#cloudiHighlight)" opacity="0.6" />
  <circle cx="110" cy="105" r="18" fill="url(#cloudiHighlight)" opacity="0.5" />
  <circle cx="100" cy="90" r="15" fill="url(#cloudiHighlight)" opacity="0.7" />
  
  <!-- Sleeping eyes -->
  <path d="M 80 100 Q 88 103 96 100" stroke="#64748b" stroke-width="3" fill="none" stroke-linecap="round" />
  <path d="M 104 100 Q 112 103 120 100" stroke="#64748b" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Peaceful mouth -->
  <circle cx="100" cy="115" r="2" fill="#64748b" />
  
  <!-- Floating raindrops with gentle animation -->
  <g>
    <animateTransform attributeName="transform" type="translate" values="0,0; 0,5; 0,0" dur="3s" repeatCount="indefinite" />
    <circle cx="70" cy="140" r="3" fill="url(#cloudiRain)" opacity="0.6" />
    <circle cx="130" cy="145" r="2.5" fill="url(#cloudiRain)" opacity="0.4" />
    <circle cx="85" cy="155" r="2" fill="url(#cloudiRain)" opacity="0.5" />
    <circle cx="115" cy="150" r="2.5" fill="url(#cloudiRain)" opacity="0.3" />
  </g>

  <!-- "Zzz" sleeping -->
  <text x="150" y="60" font-size="10" fill="#666" opacity="0.8">Z</text>
  <text x="157" y="55" font-size="8" fill="#666" opacity="0.6">z</text>
  <text x="162" y="51" font-size="6" fill="#666" opacity="0.4">z</text>
  
  <defs>
    <radialGradient id="cloudiBody" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#ffffff" />
      <stop offset="50%" stop-color="#f1f5f9" />
      <stop offset="100%" stop-color="#e2e8f0" />
    </radialGradient>
    <radialGradient id="cloudiHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#ffffff" />
      <stop offset="100%" stop-color="rgba(255,255,255,0.5)" />
    </radialGradient>
    <radialGradient id="cloudiRain" cx="0.5" cy="0.3">
      <stop offset="0%" stop-color="#60a5fa" />
      <stop offset="100%" stop-color="#3b82f6" />
    </radialGradient>
  </defs>
</svg>`;

const CRYSTI_BASE = `<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Crystal gradients -->
    <radialGradient id="crystiBody" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#f3e8ff;stop-opacity:1" />
      <stop offset="30%" style="stop-color:#e9d5ff;stop-opacity:1" />
      <stop offset="70%" style="stop-color:#c084fc;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#8b5cf6;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="crystiInner" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="100%" style="stop-color:rgba(255,255,255,0.3);stop-opacity:1" />
    </radialGradient>
    <linearGradient id="crystiFacet1" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#f59e0b;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="crystiFacet2" x1="1" y1="0" x2="0" y2="1">
      <stop offset="0%" style="stop-color:#f472b6;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#ec4899;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="crystiFacet3" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" style="stop-color:#34d399;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#10b981;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="crystiFacet4" x1="0" y1="1" x2="1" y2="0">
      <stop offset="0%" style="stop-color:#06b6d4;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#0891b2;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="crystiFacet5" x1="1" y1="1" x2="0" y2="0">
      <stop offset="0%" style="stop-color:#a78bfa;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#7c3aed;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="crystiFacet6" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" style="stop-color:#fb7185;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#e11d48;stop-opacity:1" />
    </linearGradient>
    <radialGradient id="crystiEye" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#e9d5ff;stop-opacity:1" />
    </radialGradient>
    <linearGradient id="crystiSmile" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" style="stop-color:#8b5cf6;stop-opacity:1" />
      <stop offset="50%" style="stop-color:#c084fc;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#8b5cf6;stop-opacity:1" />
    </linearGradient>
  </defs>
  
  <!-- Main crystal body - rounded hexagon shape -->
  <path d="M 100 50 L 140 80 L 140 130 L 100 160 L 60 130 L 60 80 Z" fill="url(#crystiBody)" data-blobbi-body="true" />
  <path d="M 100 55 L 135 82 L 135 128 L 100 155 L 65 128 L 65 82 Z" fill="url(#crystiInner)" opacity="0.7" />
  
  <!-- Crystal segments with rounded edges -->
  <path d="M 100 50 L 125 70 L 100 105 L 75 70 Z" fill="url(#crystiFacet1)" opacity="0.8" />
  <path d="M 75 70 L 60 80 L 60 105 L 100 105 Z" fill="url(#crystiFacet2)" opacity="0.7" />
  <path d="M 125 70 L 140 80 L 140 105 L 100 105 Z" fill="url(#crystiFacet3)" opacity="0.7" />
  <path d="M 60 105 L 100 105 L 75 140 L 60 130 Z" fill="url(#crystiFacet4)" opacity="0.6" />
  <path d="M 100 105 L 140 105 L 140 130 L 125 140 Z" fill="url(#crystiFacet5)" opacity="0.6" />
  <path d="M 75 140 L 100 105 L 125 140 L 100 160 Z" fill="url(#crystiFacet6)" opacity="0.8" />
  
  <!-- Eyes (white base) -->
  <circle cx="88" cy="95" r="10" fill="url(#crystiEye)" />
  <circle cx="112" cy="95" r="10" fill="url(#crystiEye)" />
  
  <!-- Pupils (dark circles + highlights) -->
  <circle cx="88" cy="95" r="6" fill="#1e1b4b" />
  <circle cx="112" cy="95" r="6" fill="#1e1b4b" />
  <circle cx="90" cy="93" r="3" fill="white" />
  <circle cx="114" cy="93" r="3" fill="white" />
  
  <!-- Mouth -->
  <path d="M 90 115 Q 100 123 110 115" stroke="url(#crystiSmile)" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Floating sparkles with gentle animation -->
  <g>
    <animateTransform attributeName="transform" type="rotate" from="0 100 100" to="360 100 100" dur="15s" repeatCount="indefinite" />
    <circle cx="65" cy="65" r="2" fill="#fbbf24" opacity="0.9" />
    <circle cx="135" cy="70" r="1.5" fill="#f472b6" opacity="0.8" />
    <circle cx="70" cy="140" r="1" fill="#06b6d4" opacity="0.7" />
    <circle cx="130" cy="135" r="2" fill="#fbbf24" opacity="0.6" />
  </g>
  <g>
    <animateTransform attributeName="transform" type="rotate" from="0 100 100" to="-360 100 100" dur="20s" repeatCount="indefinite" />
    <circle cx="50" cy="105" r="1.5" fill="#f472b6" opacity="0.8" />
    <circle cx="150" cy="110" r="1" fill="#06b6d4" opacity="0.9" />
    <circle cx="100" cy="40" r="1.5" fill="#fbbf24" opacity="0.7" />
    <circle cx="100" cy="170" r="1" fill="#f472b6" opacity="0.8" />
  </g>
</svg>`;

const CRYSTI_SLEEPING = `<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Crystal gradients -->
    <radialGradient id="crystiBody" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#f3e8ff;stop-opacity:1" />
      <stop offset="30%" style="stop-color:#e9d5ff;stop-opacity:1" />
      <stop offset="70%" style="stop-color:#c084fc;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#8b5cf6;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="crystiInner" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="100%" style="stop-color:rgba(255,255,255,0.3);stop-opacity:1" />
    </radialGradient>
    <linearGradient id="crystiFacet1" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#f59e0b;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="crystiFacet2" x1="1" y1="0" x2="0" y2="1">
      <stop offset="0%" style="stop-color:#f472b6;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#ec4899;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="crystiFacet3" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" style="stop-color:#34d399;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#10b981;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="crystiFacet4" x1="0" y1="1" x2="1" y2="0">
      <stop offset="0%" style="stop-color:#06b6d4;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#0891b2;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="crystiFacet5" x1="1" y1="1" x2="0" y2="0">
      <stop offset="0%" style="stop-color:#a78bfa;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#7c3aed;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="crystiFacet6" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" style="stop-color:#fb7185;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#e11d48;stop-opacity:1" />
    </linearGradient>
    <radialGradient id="crystiEye" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#e9d5ff;stop-opacity:1" />
    </radialGradient>
    <linearGradient id="crystiSmile" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" style="stop-color:#8b5cf6;stop-opacity:1" />
      <stop offset="50%" style="stop-color:#c084fc;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#8b5cf6;stop-opacity:1" />
    </linearGradient>
  </defs>
  
  <!-- Main crystal body - rounded hexagon shape -->
  <path d="M 100 50 L 140 80 L 140 130 L 100 160 L 60 130 L 60 80 Z" fill="url(#crystiBody)" data-blobbi-body="true" />
  <path d="M 100 55 L 135 82 L 135 128 L 100 155 L 65 128 L 65 82 Z" fill="url(#crystiInner)" opacity="0.7" />
  
  <!-- Crystal segments with rounded edges -->
  <path d="M 100 50 L 125 70 L 100 105 L 75 70 Z" fill="url(#crystiFacet1)" opacity="0.8" />
  <path d="M 75 70 L 60 80 L 60 105 L 100 105 Z" fill="url(#crystiFacet2)" opacity="0.7" />
  <path d="M 125 70 L 140 80 L 140 105 L 100 105 Z" fill="url(#crystiFacet3)" opacity="0.7" />
  <path d="M 60 105 L 100 105 L 75 140 L 60 130 Z" fill="url(#crystiFacet4)" opacity="0.6" />
  <path d="M 100 105 L 140 105 L 140 130 L 125 140 Z" fill="url(#crystiFacet5)" opacity="0.6" />
  <path d="M 75 140 L 100 105 L 125 140 L 100 160 Z" fill="url(#crystiFacet6)" opacity="0.8" />
  
  <!-- Sleeping eyes -->
  <path d="M 78 95 Q 88 98 98 95" stroke="#1e1b4b" stroke-width="3" fill="none" stroke-linecap="round" />
  <path d="M 102 95 Q 112 98 122 95" stroke="#1e1b4b" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Peaceful mouth -->
  <circle cx="100" cy="115" r="2" fill="#8b5cf6" />
  
  <!-- Floating sparkles with gentle animation -->
  <g>
    <animateTransform attributeName="transform" type="rotate" from="0 100 100" to="360 100 100" dur="15s" repeatCount="indefinite" />
    <circle cx="65" cy="65" r="2" fill="#fbbf24" opacity="0.6" />
    <circle cx="135" cy="70" r="1.5" fill="#f472b6" opacity="0.5" />
    <circle cx="70" cy="140" r="1" fill="#06b6d4" opacity="0.4" />
    <circle cx="130" cy="135" r="2" fill="#fbbf24" opacity="0.3" />
  </g>
  <g>
    <animateTransform attributeName="transform" type="rotate" from="0 100 100" to="-360 100 100" dur="20s" repeatCount="indefinite" />
    <circle cx="50" cy="105" r="1.5" fill="#f472b6" opacity="0.5" />
    <circle cx="150" cy="110" r="1" fill="#06b6d4" opacity="0.6" />
    <circle cx="100" cy="40" r="1.5" fill="#fbbf24" opacity="0.4" />
    <circle cx="100" cy="170" r="1" fill="#f472b6" opacity="0.5" />
  </g>

  <!-- "Zzz" sleeping -->
  <text x="150" y="60" font-size="10" fill="#666" opacity="0.8">Z</text>
  <text x="157" y="55" font-size="8" fill="#666" opacity="0.6">z</text>
  <text x="162" y="51" font-size="6" fill="#666" opacity="0.4">z</text>
</svg>`;

const DROPPI_BASE = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Water gradients -->
    <radialGradient id="droppiBody" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#67e8f9;stop-opacity:1" />
      <stop offset="30%" style="stop-color:#22d3ee;stop-opacity:1" />
      <stop offset="70%" style="stop-color:#06b6d4;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#0891b2;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="droppiInner" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#e0f2fe;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#7dd3fc;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="droppiHighlight" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="100%" style="stop-color:rgba(255,255,255,0.3);stop-opacity:1" />
    </radialGradient>
    <radialGradient id="droppiArm" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#22d3ee;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#0891b2;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="droppiLeg" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#06b6d4;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#0284c7;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="droppiDroplet" cx="0.5" cy="0.5">
      <stop offset="0%" style="stop-color:#7dd3fc;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#06b6d4;stop-opacity:1" />
    </radialGradient>
  </defs>
  
  <!-- Main water drop body -->
  <path d="M 100 40 Q 100 30 100 40 Q 135 60 140 110 Q 140 150 100 165 Q 60 150 60 110 Q 65 60 100 40" 
        fill="url(#droppiBody)" data-blobbi-body="true" />
  
  <!-- Inner water reflection -->
  <ellipse cx="100" cy="100" rx="35" ry="45" fill="url(#droppiInner)" opacity="0.6" />
  <ellipse cx="90" cy="80" rx="20" ry="25" fill="url(#droppiHighlight)" opacity="0.7" />
  
  <!-- Eyes (white base) -->
  <circle cx="85" cy="95" r="12" fill="white" />
  <circle cx="115" cy="95" r="12" fill="white" />
  
  <!-- Pupils (dark circles + highlights) -->
  <circle cx="85" cy="95" r="8" fill="#0891b2" />
  <circle cx="115" cy="95" r="8" fill="#0891b2" />
  <circle cx="88" cy="92" r="4" fill="white" />
  <circle cx="118" cy="92" r="4" fill="white" />
  
  <!-- Mouth -->
  <path d="M 88 115 Q 100 123 112 115" stroke="#0891b2" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Little arms -->
  <ellipse cx="60" cy="110" rx="10" ry="18" fill="url(#droppiArm)" transform="rotate(-25 60 110)" />
  <ellipse cx="140" cy="110" rx="10" ry="18" fill="url(#droppiArm)" transform="rotate(25 140 110)" />
  
  <!-- Little legs -->
  <ellipse cx="85" cy="160" rx="12" ry="10" fill="url(#droppiLeg)" />
  <ellipse cx="115" cy="160" rx="12" ry="10" fill="url(#droppiLeg)" />
  
  <!-- Water droplets floating around - grouped with rotation -->
  <g transform="translate(100 110)">
    <g>
      <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="8s" repeatCount="indefinite" />
      <circle cx="-45" cy="-35" r="3" fill="url(#droppiDroplet)" opacity="0.8" />
    </g>
  </g>
  
  <g transform="translate(100 110)">
    <g>
      <animateTransform attributeName="transform" type="rotate" from="0" to="-360" dur="9s" repeatCount="indefinite" />
      <circle cx="45" cy="-30" r="2.5" fill="url(#droppiDroplet)" opacity="0.6" />
    </g>
  </g>
  
  <g transform="translate(100 110)">
    <g>
      <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="7s" repeatCount="indefinite" />
      <circle cx="-50" cy="25" r="2" fill="url(#droppiDroplet)" opacity="0.7" />
    </g>
  </g>
  
  <g transform="translate(100 110)">
    <g>
      <animateTransform attributeName="transform" type="rotate" from="0" to="-360" dur="10s" repeatCount="indefinite" />
      <circle cx="50" cy="20" r="2.5" fill="url(#droppiDroplet)" opacity="0.5" />
    </g>
  </g>
</svg>`;

const DROPPI_SLEEPING = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Water gradients -->
    <radialGradient id="droppiBody" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#67e8f9;stop-opacity:1" />
      <stop offset="30%" style="stop-color:#22d3ee;stop-opacity:1" />
      <stop offset="70%" style="stop-color:#06b6d4;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#0891b2;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="droppiInner" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#e0f2fe;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#7dd3fc;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="droppiHighlight" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="100%" style="stop-color:rgba(255,255,255,0.3);stop-opacity:1" />
    </radialGradient>
    <radialGradient id="droppiArm" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#22d3ee;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#0891b2;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="droppiLeg" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#06b6d4;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#0284c7;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="droppiDroplet" cx="0.5" cy="0.5">
      <stop offset="0%" style="stop-color:#7dd3fc;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#06b6d4;stop-opacity:1" />
    </radialGradient>
  </defs>
  
  <!-- Main water drop body -->
  <path d="M 100 40 Q 100 30 100 40 Q 135 60 140 110 Q 140 150 100 165 Q 60 150 60 110 Q 65 60 100 40" 
        fill="url(#droppiBody)" data-blobbi-body="true" />
  
  <!-- Inner water reflection -->
  <ellipse cx="100" cy="100" rx="35" ry="45" fill="url(#droppiInner)" opacity="0.6" />
  <ellipse cx="90" cy="80" rx="20" ry="25" fill="url(#droppiHighlight)" opacity="0.7" />
  
  <!-- Sleeping eyes -->
  <path d="M 73 95 Q 85 98 97 95" stroke="#0891b2" stroke-width="3" fill="none" stroke-linecap="round" />
  <path d="M 103 95 Q 115 98 127 95" stroke="#0891b2" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Peaceful mouth -->
  <circle cx="100" cy="115" r="2" fill="#0891b2" />
  
  <!-- Little arms -->
  <ellipse cx="60" cy="110" rx="10" ry="18" fill="url(#droppiArm)" transform="rotate(-25 60 110)" />
  <ellipse cx="140" cy="110" rx="10" ry="18" fill="url(#droppiArm)" transform="rotate(25 140 110)" />
  
  <!-- Little legs -->
  <ellipse cx="85" cy="160" rx="12" ry="10" fill="url(#droppiLeg)" />
  <ellipse cx="115" cy="160" rx="12" ry="10" fill="url(#droppiLeg)" />
  
  <!-- Water droplets floating around - grouped with slower rotation -->
  <g transform="translate(100 110)">
    <g>
      <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="12s" repeatCount="indefinite" />
      <circle cx="-45" cy="-35" r="3" fill="url(#droppiDroplet)" opacity="0.5" />
    </g>
  </g>
  
  <g transform="translate(100 110)">
    <g>
      <animateTransform attributeName="transform" type="rotate" from="0" to="-360" dur="15s" repeatCount="indefinite" />
      <circle cx="45" cy="-30" r="2.5" fill="url(#droppiDroplet)" opacity="0.4" />
    </g>
  </g>
  
  <g transform="translate(100 110)">
    <g>
      <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="10s" repeatCount="indefinite" />
      <circle cx="-50" cy="25" r="2" fill="url(#droppiDroplet)" opacity="0.4" />
    </g>
  </g>
  
  <g transform="translate(100 110)">
    <g>
      <animateTransform attributeName="transform" type="rotate" from="0" to="-360" dur="18s" repeatCount="indefinite" />
      <circle cx="50" cy="20" r="2.5" fill="url(#droppiDroplet)" opacity="0.3" />
    </g>
  </g>

  <!-- "Zzz" sleeping -->
  <text x="150" y="60" font-size="10" fill="#666" opacity="0.8">Z</text>
  <text x="157" y="55" font-size="8" fill="#666" opacity="0.6">z</text>
  <text x="162" y="51" font-size="6" fill="#666" opacity="0.4">z</text>
</svg>`;

const FLAMMI_BASE = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <!-- Flame gradients -->
    <radialGradient id="flammiBody" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#fbbf24" />
      <stop offset="30%" stop-color="#f97316" />
      <stop offset="70%" stop-color="#ef4444" />
      <stop offset="100%" stop-color="#dc2626" />
    </radialGradient>
    <radialGradient id="flammiInner" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#fde047" />
      <stop offset="50%" stop-color="#fbbf24" />
      <stop offset="100%" stop-color="#f97316" />
    </radialGradient>
    <radialGradient id="flammiCore" cx="0.5" cy="0.4">
      <stop offset="0%" stop-color="#fef3c7" />
      <stop offset="100%" stop-color="#fde047" />
    </radialGradient>
    <radialGradient id="flammiArm" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#f97316" />
      <stop offset="100%" stop-color="#dc2626" />
    </radialGradient>
    <radialGradient id="flammiLeg" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#ef4444" />
      <stop offset="100%" stop-color="#b91c1c" />
    </radialGradient>
    <radialGradient id="flammiEmber" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#fde047" />
      <stop offset="100%" stop-color="#f97316" />
    </radialGradient>
  </defs>

  <!-- Larger rotating flames -->
  <g transform="rotate(0 100 110)">
    <path d="M45 80 Q50 65 55 80 Q50 90 45 80 Z" fill="url(#flammiEmber)" opacity="0.8" />
    <animateTransform attributeName="transform" type="rotate" from="0 100 110" to="360 100 110" dur="4s" repeatCount="indefinite" />
  </g>
  <g transform="rotate(0 100 110)">
    <path d="M155 85 Q160 70 165 85 Q160 95 155 85 Z" fill="url(#flammiEmber)" opacity="0.6" />
    <animateTransform attributeName="transform" type="rotate" from="0 100 110" to="-360 100 110" dur="6s" repeatCount="indefinite" />
  </g>
  <g transform="rotate(0 100 110)">
    <path d="M40 130 Q45 115 50 130 Q45 140 40 130 Z" fill="url(#flammiEmber)" opacity="0.7" />
    <animateTransform attributeName="transform" type="rotate" from="0 100 110" to="360 100 110" dur="7s" repeatCount="indefinite" />
  </g>
  <g transform="rotate(0 100 110)">
    <path d="M160 125 Q165 110 170 125 Q165 135 160 125 Z" fill="url(#flammiEmber)" opacity="0.5" />
    <animateTransform attributeName="transform" type="rotate" from="0 100 110" to="-360 100 110" dur="5s" repeatCount="indefinite" />
  </g>

  <!-- Flammy Body -->
  <path d="M 100 160 Q 60 140 50 110 Q 45 80 70 60 Q 80 40 100 25 Q 120 40 130 60 Q 155 80 150 110 Q 140 140 100 160 Z" fill="url(#flammiBody)" data-blobbi-body="true" />
  <path d="M 100 155 Q 65 138 58 115 Q 55 90 75 70 Q 82 50 100 35 Q 118 50 125 70 Q 145 90 142 115 Q 135 138 100 155 Z" fill="url(#flammiInner)" opacity="0.8" />
  <path d="M 100 145 Q 70 130 65 110 Q 62 95 80 80 Q 85 65 100 55 Q 115 65 120 80 Q 138 95 135 110 Q 130 130 100 145 Z" fill="url(#flammiCore)" opacity="0.9" />

  <!-- Eyes (white base) -->
  <circle cx="88" cy="100" r="10" fill="white" />
  <circle cx="112" cy="100" r="10" fill="white" />
  
  <!-- Pupils (dark circles + highlights) -->
  <circle cx="88" cy="100" r="6" fill="#1f2937" />
  <circle cx="112" cy="100" r="6" fill="#1f2937" />
  <circle cx="90" cy="98" r="3" fill="white" />
  <circle cx="114" cy="98" r="3" fill="white" />

  <!-- Mouth -->
  <path d="M 88 115 Q 100 125 112 115" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />

  <!-- Arms -->
  <ellipse cx="55" cy="110" rx="8" ry="15" fill="url(#flammiArm)" transform="rotate(-30 55 110)" />
  <ellipse cx="145" cy="110" rx="8" ry="15" fill="url(#flammiArm)" transform="rotate(30 145 110)" />

  <!-- Legs -->
  <ellipse cx="90" cy="155" rx="10" ry="8" fill="url(#flammiLeg)" />
  <ellipse cx="110" cy="155" rx="10" ry="8" fill="url(#flammiLeg)" />
</svg>`;

const FLAMMI_SLEEPING = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <!-- Flame gradients -->
    <radialGradient id="flammiBody" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#fbbf24" />
      <stop offset="30%" stop-color="#f97316" />
      <stop offset="70%" stop-color="#ef4444" />
      <stop offset="100%" stop-color="#dc2626" />
    </radialGradient>
    <radialGradient id="flammiInner" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#fde047" />
      <stop offset="50%" stop-color="#fbbf24" />
      <stop offset="100%" stop-color="#f97316" />
    </radialGradient>
    <radialGradient id="flammiCore" cx="0.5" cy="0.4">
      <stop offset="0%" stop-color="#fef3c7" />
      <stop offset="100%" stop-color="#fde047" />
    </radialGradient>
    <radialGradient id="flammiArm" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#f97316" />
      <stop offset="100%" stop-color="#dc2626" />
    </radialGradient>
    <radialGradient id="flammiLeg" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#ef4444" />
      <stop offset="100%" stop-color="#b91c1c" />
    </radialGradient>
    <radialGradient id="flammiEmber" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#fde047" />
      <stop offset="100%" stop-color="#f97316" />
    </radialGradient>
  </defs>

  <!-- Slower rotating flames for sleeping state -->
  <g transform="rotate(0 100 110)">
    <path d="M45 80 Q50 65 55 80 Q50 90 45 80 Z" fill="url(#flammiEmber)" opacity="0.5" />
    <animateTransform attributeName="transform" type="rotate" from="0 100 110" to="360 100 110" dur="8s" repeatCount="indefinite" />
  </g>
  <g transform="rotate(0 100 110)">
    <path d="M155 85 Q160 70 165 85 Q160 95 155 85 Z" fill="url(#flammiEmber)" opacity="0.4" />
    <animateTransform attributeName="transform" type="rotate" from="0 100 110" to="-360 100 110" dur="12s" repeatCount="indefinite" />
  </g>
  <g transform="rotate(0 100 110)">
    <path d="M40 130 Q45 115 50 130 Q45 140 40 130 Z" fill="url(#flammiEmber)" opacity="0.4" />
    <animateTransform attributeName="transform" type="rotate" from="0 100 110" to="360 100 110" dur="14s" repeatCount="indefinite" />
  </g>
  <g transform="rotate(0 100 110)">
    <path d="M160 125 Q165 110 170 125 Q165 135 160 125 Z" fill="url(#flammiEmber)" opacity="0.3" />
    <animateTransform attributeName="transform" type="rotate" from="0 100 110" to="-360 100 110" dur="10s" repeatCount="indefinite" />
  </g>

  <!-- Flammy Body -->
  <path d="M 100 160 Q 60 140 50 110 Q 45 80 70 60 Q 80 40 100 25 Q 120 40 130 60 Q 155 80 150 110 Q 140 140 100 160 Z" fill="url(#flammiBody)" data-blobbi-body="true" />
  <path d="M 100 155 Q 65 138 58 115 Q 55 90 75 70 Q 82 50 100 35 Q 118 50 125 70 Q 145 90 142 115 Q 135 138 100 155 Z" fill="url(#flammiInner)" opacity="0.8" />
  <path d="M 100 145 Q 70 130 65 110 Q 62 95 80 80 Q 85 65 100 55 Q 115 65 120 80 Q 138 95 135 110 Q 130 130 100 145 Z" fill="url(#flammiCore)" opacity="0.9" />

  <!-- Sleeping eyes -->
  <path d="M 78 100 Q 88 103 98 100" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  <path d="M 102 100 Q 112 103 122 100" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />

  <!-- Peaceful mouth -->
  <circle cx="100" cy="115" r="2" fill="#1f2937" />

  <!-- Arms -->
  <ellipse cx="55" cy="110" rx="8" ry="15" fill="url(#flammiArm)" transform="rotate(-30 55 110)" />
  <ellipse cx="145" cy="110" rx="8" ry="15" fill="url(#flammiArm)" transform="rotate(30 145 110)" />

  <!-- Legs -->
  <ellipse cx="90" cy="155" rx="10" ry="8" fill="url(#flammiLeg)" />
  <ellipse cx="110" cy="155" rx="10" ry="8" fill="url(#flammiLeg)" />

  <!-- "Zzz" sleeping -->
  <text x="150" y="60" font-size="10" fill="#666" opacity="0.8">Z</text>
  <text x="157" y="55" font-size="8" fill="#666" opacity="0.6">z</text>
  <text x="162" y="51" font-size="6" fill="#666" opacity="0.4">z</text>
</svg>`;

const FROGGI_BASE = `<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Gradients for 3D effect -->
    <radialGradient id="froggiBody3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#86efac;stop-opacity:1" />
      <stop offset="40%" style="stop-color:#22c55e;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#15803d;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="froggiEyeBase3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#4ade80;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#16a34a;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="froggiEyeWhite3D" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="70%" style="stop-color:#f5f5f4;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#e7e5e4;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="froggiPupil3D" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#374151;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#1e293b;stop-opacity:1" />
    </radialGradient>
    <linearGradient id="froggiMouth3D" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" style="stop-color:#374151;stop-opacity:1" />
      <stop offset="50%" style="stop-color:#1e293b;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#374151;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="froggiMouthHighlight" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" style="stop-color:rgba(255,255,255,0.3);stop-opacity:1" />
      <stop offset="50%" style="stop-color:rgba(255,255,255,0.1);stop-opacity:1" />
      <stop offset="100%" style="stop-color:rgba(255,255,255,0.3);stop-opacity:1" />
    </linearGradient>
    <radialGradient id="froggiNostril3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#16a34a;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#14532d;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="froggiNostrilHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#4ade80;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#16a34a;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="froggiFeet3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#4ade80;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#16a34a;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="froggiFeetHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#86efac;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#4ade80;stop-opacity:1" />
    </radialGradient>
    <linearGradient id="froggiToe3D" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" style="stop-color:#16a34a;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#14532d;stop-opacity:1" />
    </linearGradient>
  </defs>
  
  <!-- Flattened oval body -->
  <ellipse cx="100" cy="120" rx="70" ry="50" fill="url(#froggiBody3D)" data-blobbi-body="true" />
  
  <!-- Big circular pop-out eyes -->
  <circle cx="70" cy="80" r="27" fill="url(#froggiEyeBase3D)" />
  <circle cx="130" cy="80" r="27" fill="url(#froggiEyeBase3D)" />
  
  <!-- Eyes (white/base eye shapes) -->
  <circle cx="70" cy="80" r="22" fill="url(#froggiEyeWhite3D)" />
  <circle cx="130" cy="80" r="22" fill="url(#froggiEyeWhite3D)" />
  
  <!-- Pupils (pupil + highlights) -->
  <circle cx="70" cy="80" r="16" fill="url(#froggiPupil3D)" />
  <circle cx="130" cy="80" r="16" fill="url(#froggiPupil3D)" />
  <circle cx="74" cy="76" r="6" fill="white" opacity="0.9" />
  <circle cx="134" cy="76" r="6" fill="white" opacity="0.9" />
  
  <!-- Mouth -->
  <path d="M 45 120 Q 100 145 155 120" stroke="url(#froggiMouth3D)" stroke-width="5" fill="none" stroke-linecap="round" />
  <path d="M 50 122 Q 100 142 150 122" stroke="url(#froggiMouthHighlight)" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Enhanced nostrils -->
  <ellipse cx="90" cy="110" rx="4" ry="6" fill="url(#froggiNostril3D)" />
  <ellipse cx="110" cy="110" rx="4" ry="6" fill="url(#froggiNostril3D)" />
  <ellipse cx="90" cy="108" rx="2" ry="3" fill="url(#froggiNostrilHighlight)" />
  <ellipse cx="110" cy="108" rx="2" ry="3" fill="url(#froggiNostrilHighlight)" />
  
  <!-- Enhanced webbed feet -->
  <ellipse cx="60" cy="160" rx="22" ry="12" fill="url(#froggiFeet3D)" />
  <ellipse cx="140" cy="160" rx="22" ry="12" fill="url(#froggiFeet3D)" />
  <ellipse cx="60" cy="158" rx="18" ry="8" fill="url(#froggiFeetHighlight)" />
  <ellipse cx="140" cy="158" rx="18" ry="8" fill="url(#froggiFeetHighlight)" />
  
  <!-- Enhanced webbed toes -->
  <path d="M 43 160 Q 47 155 52 160" stroke="url(#froggiToe3D)" stroke-width="2.5" fill="none" stroke-linecap="round" />
  <path d="M 53 160 Q 57 155 62 160" stroke="url(#froggiToe3D)" stroke-width="2.5" fill="none" stroke-linecap="round" />
  <path d="M 63 160 Q 67 155 72 160" stroke="url(#froggiToe3D)" stroke-width="2.5" fill="none" stroke-linecap="round" />
  <path d="M 123 160 Q 127 155 132 160" stroke="url(#froggiToe3D)" stroke-width="2.5" fill="none" stroke-linecap="round" />
  <path d="M 133 160 Q 137 155 142 160" stroke="url(#froggiToe3D)" stroke-width="2.5" fill="none" stroke-linecap="round" />
  <path d="M 143 160 Q 147 155 152 160" stroke="url(#froggiToe3D)" stroke-width="2.5" fill="none" stroke-linecap="round" />
  
  <!-- Soft skin texture details -->
  <ellipse cx="75" cy="135" rx="4" ry="3" fill="rgba(255,255,255,0.2)" />
  <ellipse cx="125" cy="130" rx="3.5" ry="2.5" fill="rgba(255,255,255,0.2)" />
  <ellipse cx="85" cy="145" rx="3" ry="2" fill="rgba(255,255,255,0.15)" />
  <ellipse cx="115" cy="140" rx="3.5" ry="2.5" fill="rgba(255,255,255,0.15)" />
</svg>`;

const FROGGI_SLEEPING = `<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Gradients for 3D effect -->
    <radialGradient id="froggiBody3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#86efac;stop-opacity:1" />
      <stop offset="40%" style="stop-color:#22c55e;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#15803d;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="froggiEyeBase3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#4ade80;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#16a34a;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="froggiEyeWhite3D" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="70%" style="stop-color:#f5f5f4;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#e7e5e4;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="froggiPupil3D" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#374151;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#1e293b;stop-opacity:1" />
    </radialGradient>
    <linearGradient id="froggiMouth3D" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" style="stop-color:#374151;stop-opacity:1" />
      <stop offset="50%" style="stop-color:#1e293b;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#374151;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="froggiMouthHighlight" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" style="stop-color:rgba(255,255,255,0.3);stop-opacity:1" />
      <stop offset="50%" style="stop-color:rgba(255,255,255,0.1);stop-opacity:1" />
      <stop offset="100%" style="stop-color:rgba(255,255,255,0.3);stop-opacity:1" />
    </linearGradient>
    <radialGradient id="froggiNostril3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#16a34a;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#14532d;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="froggiNostrilHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#4ade80;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#16a34a;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="froggiFeet3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#4ade80;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#16a34a;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="froggiFeetHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#86efac;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#4ade80;stop-opacity:1" />
    </radialGradient>
    <linearGradient id="froggiToe3D" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" style="stop-color:#16a34a;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#14532d;stop-opacity:1" />
    </linearGradient>
  </defs>
  
  <!-- Flattened oval body -->
  <ellipse cx="100" cy="120" rx="70" ry="50" fill="url(#froggiBody3D)" data-blobbi-body="true" />
  
  <!-- Big circular pop-out eyes -->
  <circle cx="70" cy="80" r="27" fill="url(#froggiEyeBase3D)" />
  <circle cx="130" cy="80" r="27" fill="url(#froggiEyeBase3D)" />
  
  <!-- Sleeping eyes -->
  <path d="M 54 80 Q 70 83 86 80" stroke="#1e293b" stroke-width="3" fill="none" stroke-linecap="round" />
  <path d="M 114 80 Q 130 83 146 80" stroke="#1e293b" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Peaceful mouth -->
  <circle cx="100" cy="125" r="2" fill="#1e293b" />
  
  <!-- Enhanced nostrils -->
  <ellipse cx="90" cy="110" rx="4" ry="6" fill="url(#froggiNostril3D)" />
  <ellipse cx="110" cy="110" rx="4" ry="6" fill="url(#froggiNostril3D)" />
  <ellipse cx="90" cy="108" rx="2" ry="3" fill="url(#froggiNostrilHighlight)" />
  <ellipse cx="110" cy="108" rx="2" ry="3" fill="url(#froggiNostrilHighlight)" />
  
  <!-- Enhanced webbed feet -->
  <ellipse cx="60" cy="160" rx="22" ry="12" fill="url(#froggiFeet3D)" />
  <ellipse cx="140" cy="160" rx="22" ry="12" fill="url(#froggiFeet3D)" />
  <ellipse cx="60" cy="158" rx="18" ry="8" fill="url(#froggiFeetHighlight)" />
  <ellipse cx="140" cy="158" rx="18" ry="8" fill="url(#froggiFeetHighlight)" />
  
  <!-- Enhanced webbed toes -->
  <path d="M 43 160 Q 47 155 52 160" stroke="url(#froggiToe3D)" stroke-width="2.5" fill="none" stroke-linecap="round" />
  <path d="M 53 160 Q 57 155 62 160" stroke="url(#froggiToe3D)" stroke-width="2.5" fill="none" stroke-linecap="round" />
  <path d="M 63 160 Q 67 155 72 160" stroke="url(#froggiToe3D)" stroke-width="2.5" fill="none" stroke-linecap="round" />
  <path d="M 123 160 Q 127 155 132 160" stroke="url(#froggiToe3D)" stroke-width="2.5" fill="none" stroke-linecap="round" />
  <path d="M 133 160 Q 137 155 142 160" stroke="url(#froggiToe3D)" stroke-width="2.5" fill="none" stroke-linecap="round" />
  <path d="M 143 160 Q 147 155 152 160" stroke="url(#froggiToe3D)" stroke-width="2.5" fill="none" stroke-linecap="round" />
  
  <!-- Soft skin texture details -->
  <ellipse cx="75" cy="135" rx="4" ry="3" fill="rgba(255,255,255,0.2)" />
  <ellipse cx="125" cy="130" rx="3.5" ry="2.5" fill="rgba(255,255,255,0.2)" />
  <ellipse cx="85" cy="145" rx="3" ry="2" fill="rgba(255,255,255,0.15)" />
  <ellipse cx="115" cy="140" rx="3.5" ry="2.5" fill="rgba(255,255,255,0.15)" />

  <!-- "Zzz" sleeping -->
  <text x="150" y="60" font-size="10" fill="#666" opacity="0.8">Z</text>
  <text x="157" y="55" font-size="8" fill="#666" opacity="0.6">z</text>
  <text x="162" y="51" font-size="6" fill="#666" opacity="0.4">z</text>
</svg>`;

const LEAFY_BASE = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">  
  <!-- Sunflower stem -->
  <rect x="96" y="120" width="8" height="55" fill="url(#leafyStem)" rx="4" />
  <rect x="98" y="125" width="4" height="50" fill="url(#leafyStemHighlight)" rx="2" opacity="0.6" />
  
  <!-- Stem leaves -->
  <ellipse cx="85" cy="140" rx="15" ry="8" fill="url(#leafyStemLeaf)" transform="rotate(-30 85 140)" />
  <ellipse cx="115" cy="150" rx="15" ry="8" fill="url(#leafyStemLeaf)" transform="rotate(30 115 150)" />
  <ellipse cx="87" cy="140" rx="10" ry="5" fill="url(#leafyStemLeafHighlight)" transform="rotate(-30 87 140)" opacity="0.7" />
  <ellipse cx="113" cy="150" rx="10" ry="5" fill="url(#leafyStemLeafHighlight)" transform="rotate(30 113 150)" opacity="0.7" />
  
  <!-- Sunflower petals - outer ring -->
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(0 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(22.5 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(45 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(67.5 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(90 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(112.5 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(135 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(157.5 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(180 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(202.5 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(225 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(247.5 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(270 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(292.5 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(315 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(337.5 100 85)" />
  
  <!-- Sunflower center - outer ring -->
  <circle cx="100" cy="85" r="30" fill="url(#leafyCenter)" data-blobbi-body="true" />
  <circle cx="100" cy="85" r="25" fill="url(#leafyCenterInner)" />
  
  <!-- Eyes (white base) -->
  <circle cx="90" cy="82" r="8" fill="white" />
  <circle cx="110" cy="82" r="8" fill="white" />
  
  <!-- Pupils (dark circles + highlights) -->
  <circle cx="90" cy="82" r="5" fill="#1f2937" />
  <circle cx="110" cy="82" r="5" fill="#1f2937" />
  <circle cx="92" cy="80" r="2" fill="white" />
  <circle cx="112" cy="80" r="2" fill="white" />
  
  <!-- Mouth -->
  <path d="M 88 92 Q 100 100 112 92" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Floating pollen -->
  <circle cx="55" cy="60" r="2" fill="url(#leafyPollen)" opacity="0.8" />
  <circle cx="145" cy="65" r="1.5" fill="url(#leafyPollen)" opacity="0.6" />
  <circle cx="50" cy="110" r="1" fill="url(#leafyPollen)" opacity="0.7" />
  <circle cx="150" cy="105" r="2" fill="url(#leafyPollen)" opacity="0.5" />
  <circle cx="75" cy="45" r="1.5" fill="url(#leafyPollen)" opacity="0.9" />
  <circle cx="125" cy="50" r="1" fill="url(#leafyPollen)" opacity="0.8" />
  
  <!-- Leavy pot -->
  <path d="M 75 160 L 80 175 L 120 175 L 125 160 Z" fill="url(#leafyPot)" />
  <rect x="75" y="160" width="50" height="5" fill="url(#leafyPotRim)" rx="2" />

  <defs>
    <radialGradient id="leafyStem" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#22c55e" />
      <stop offset="100%" stop-color="#15803d" />
    </radialGradient>
    <radialGradient id="leafyStemHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#4ade80" />
      <stop offset="100%" stop-color="#22c55e" />
    </radialGradient>
    <radialGradient id="leafyStemLeaf" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#4ade80" />
      <stop offset="100%" stop-color="#16a34a" />
    </radialGradient>
    <radialGradient id="leafyStemLeafHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#86efac" />
      <stop offset="100%" stop-color="#4ade80" />
    </radialGradient>
    <radialGradient id="leafyPetal" cx="0.3" cy="0.3">
      <stop offset="100%" stop-color="#eab308" />
      <!-- <stop offset="70%" stop-color="#eab308" /> -->
      <stop offset="30%" stop-color="#fde047" />
      <stop offset="0%" stop-color="#ffce09" />
    </radialGradient>
    <radialGradient id="leafyCenter" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#a16207" />
      <stop offset="50%" stop-color="#92400e" />
      <stop offset="100%" stop-color="#78350f" />
    </radialGradient>
    <radialGradient id="leafyCenterInner" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#d97706" />
      <stop offset="100%" stop-color="#a16207" />
    </radialGradient>
    <radialGradient id="leafySeed" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#451a03" />
      <stop offset="100%" stop-color="#292524" />
    </radialGradient>
    <radialGradient id="leafyArm" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#4ade80" />
      <stop offset="100%" stop-color="#16a34a" />
    </radialGradient>
    <radialGradient id="leafyRoot" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#a16207" />
      <stop offset="100%" stop-color="#78350f" />
    </radialGradient>
    <radialGradient id="leafyPollen" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#fef3c7" />
      <stop offset="100%" stop-color="#fde047" />
    </radialGradient>
        <radialGradient id="leafyPot" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#dc2626" />
      <stop offset="100%" stop-color="#991b1b" />
    </radialGradient>
    <radialGradient id="leafyPotRim" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#ef4444" />
      <stop offset="100%" stop-color="#dc2626" />
    </radialGradient>
  </defs>
</svg>`;

const LEAFY_SLEEPING = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">  
  <!-- Sunflower stem -->
  <rect x="96" y="120" width="8" height="55" fill="url(#leafyStem)" rx="4" />
  <rect x="98" y="125" width="4" height="50" fill="url(#leafyStemHighlight)" rx="2" opacity="0.6" />
  
  <!-- Stem leaves -->
  <ellipse cx="85" cy="140" rx="15" ry="8" fill="url(#leafyStemLeaf)" transform="rotate(-30 85 140)" />
  <ellipse cx="115" cy="150" rx="15" ry="8" fill="url(#leafyStemLeaf)" transform="rotate(30 115 150)" />
  <ellipse cx="87" cy="140" rx="10" ry="5" fill="url(#leafyStemLeafHighlight)" transform="rotate(-30 87 140)" opacity="0.7" />
  <ellipse cx="113" cy="150" rx="10" ry="5" fill="url(#leafyStemLeafHighlight)" transform="rotate(30 113 150)" opacity="0.7" />
  
  <!-- Sunflower petals - outer ring -->
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(0 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(22.5 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(45 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(67.5 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(90 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(112.5 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(135 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(157.5 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(180 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(202.5 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(225 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(247.5 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(270 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(292.5 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(315 100 85)" />
  <ellipse cx="100" cy="85" rx="45" ry="12" fill="url(#leafyPetal)" transform="rotate(337.5 100 85)" />
  
  <!-- Sunflower center - outer ring -->
  <circle cx="100" cy="85" r="30" fill="url(#leafyCenter)" data-blobbi-body="true" />
  <circle cx="100" cy="85" r="25" fill="url(#leafyCenterInner)" />
  
  <!-- Sleeping eyes -->
  <path d="M 82 82 Q 90 85 98 82" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  <path d="M 102 82 Q 110 85 118 82" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Peaceful mouth -->
  <circle cx="100" cy="92" r="2" fill="#1f2937" />
  
  <!-- Little arms - small leaves -->
  <ellipse cx="60" cy="85" rx="12" ry="6" fill="url(#leafyArm)" transform="rotate(-20 60 85)" />
  <ellipse cx="140" cy="85" rx="12" ry="6" fill="url(#leafyArm)" transform="rotate(20 140 85)" />
  
  <!-- Base/roots -->
  <ellipse cx="95" cy="170" rx="8" ry="6" fill="url(#leafyRoot)" />
  <ellipse cx="105" cy="170" rx="8" ry="6" fill="url(#leafyRoot)" />
  
  <!-- Floating pollen with gentle animation -->
  <g>
    <animateTransform attributeName="transform" type="translate" values="0,0; 2,3; 0,0" dur="4s" repeatCount="indefinite" />
    <circle cx="55" cy="60" r="2" fill="url(#leafyPollen)" opacity="0.5" />
    <circle cx="145" cy="65" r="1.5" fill="url(#leafyPollen)" opacity="0.4" />
    <circle cx="50" cy="110" r="1" fill="url(#leafyPollen)" opacity="0.4" />
    <circle cx="150" cy="105" r="2" fill="url(#leafyPollen)" opacity="0.3" />
    <circle cx="75" cy="45" r="1.5" fill="url(#leafyPollen)" opacity="0.6" />
    <circle cx="125" cy="50" r="1" fill="url(#leafyPollen)" opacity="0.5" />
  </g>

  <!-- "Zzz" sleeping -->
  <text x="150" y="60" font-size="10" fill="#666" opacity="0.8">Z</text>
  <text x="157" y="55" font-size="8" fill="#666" opacity="0.6">z</text>
  <text x="162" y="51" font-size="6" fill="#666" opacity="0.4">z</text>
  
  <defs>
    <radialGradient id="leafyStem" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#22c55e" />
      <stop offset="100%" stop-color="#15803d" />
    </radialGradient>
    <radialGradient id="leafyStemHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#4ade80" />
      <stop offset="100%" stop-color="#22c55e" />
    </radialGradient>
    <radialGradient id="leafyStemLeaf" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#4ade80" />
      <stop offset="100%" stop-color="#16a34a" />
    </radialGradient>
    <radialGradient id="leafyStemLeafHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#86efac" />
      <stop offset="100%" stop-color="#4ade80" />
    </radialGradient>
    <radialGradient id="leafyPetal" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#fef3c7" />
      <stop offset="30%" stop-color="#fde047" />
      <stop offset="100%" stop-color="#eab308" />
    </radialGradient>
    <radialGradient id="leafyCenter" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#a16207" />
      <stop offset="50%" stop-color="#92400e" />
      <stop offset="100%" stop-color="#78350f" />
    </radialGradient>
    <radialGradient id="leafyCenterInner" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#d97706" />
      <stop offset="100%" stop-color="#a16207" />
    </radialGradient>
    <radialGradient id="leafySeed" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#451a03" />
      <stop offset="100%" stop-color="#292524" />
    </radialGradient>
    <radialGradient id="leafyArm" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#4ade80" />
      <stop offset="100%" stop-color="#16a34a" />
    </radialGradient>
    <radialGradient id="leafyRoot" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#a16207" />
      <stop offset="100%" stop-color="#78350f" />
    </radialGradient>
    <radialGradient id="leafyPollen" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#fef3c7" />
      <stop offset="100%" stop-color="#fde047" />
    </radialGradient>
  </defs>
</svg>`;

const MUSHIE_BASE = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <!-- Mushroom stem -->
  <ellipse cx="100" cy="140" rx="25" ry="40" fill="url(#mushieStem)" />
  <ellipse cx="100" cy="135" rx="20" ry="35" fill="url(#mushieStemHighlight)" opacity="0.6" />
  
  <!-- Mushroom cap -->
  <path d="M 50 110 Q 50 70 100 60 Q 150 70 150 110 Z" fill="url(#mushieCap)" data-blobbi-body="true" />
  <path d="M 55 108 Q 55 75 100 65 Q 145 75 145 108 Z" fill="url(#mushieCapHighlight)" opacity="0.7" />
  
  <!-- Cap spots -->
  <circle cx="80" cy="85" r="8" fill="white" opacity="0.8" />
  <circle cx="120" cy="80" r="10" fill="white" opacity="0.8" />
  <circle cx="100" cy="95" r="6" fill="white" opacity="0.7" />
  <circle cx="130" cy="100" r="5" fill="white" opacity="0.6" />
  <circle cx="70" cy="100" r="5" fill="white" opacity="0.6" />
  
  <!-- Eyes (white base) -->
  <circle cx="88" cy="130" r="8" fill="white" />
  <circle cx="112" cy="130" r="8" fill="white" />
  
  <!-- Pupils (dark circles + highlights) -->
  <circle cx="88" cy="130" r="5" fill="#1f2937" />
  <circle cx="112" cy="130" r="5" fill="#1f2937" />
  <circle cx="90" cy="128" r="2" fill="white" />
  <circle cx="114" cy="128" r="2" fill="white" />
  
  <!-- Mouth -->
  <path d="M 88 145 Q 100 153 112 145" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Little arms -->
  <ellipse cx="70" cy="140" rx="8" ry="12" fill="url(#mushieArm)" transform="rotate(-20 70 140)" />
  <ellipse cx="130" cy="140" rx="8" ry="12" fill="url(#mushieArm)" transform="rotate(20 130 140)" />
  
  <!-- Floating spores -->
  <circle cx="55" cy="120" r="2" fill="url(#mushieSpore)" opacity="0.8" />
  <circle cx="145" cy="115" r="1.5" fill="url(#mushieSpore)" opacity="0.6" />
  <circle cx="50" cy="90" r="1" fill="url(#mushieSpore)" opacity="0.7" />
  <circle cx="150" cy="95" r="2" fill="url(#mushieSpore)" opacity="0.5" />
  <circle cx="65" cy="70" r="1.5" fill="url(#mushieSpore)" opacity="0.6" />
  <circle cx="135" cy="65" r="1" fill="url(#mushieSpore)" opacity="0.8" />
  
  <defs>
    <radialGradient id="mushieStem" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#fef3c7" />
      <stop offset="30%" stop-color="#fde68a" />
      <stop offset="70%" stop-color="#fbbf24" />
      <stop offset="100%" stop-color="#f59e0b" />
    </radialGradient>
    <radialGradient id="mushieStemHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#ffffff" />
      <stop offset="100%" stop-color="rgba(255,255,255,0.3)" />
    </radialGradient>
    <radialGradient id="mushieCap" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#f87171" />
      <stop offset="30%" stop-color="#ef4444" />
      <stop offset="70%" stop-color="#dc2626" />
      <stop offset="100%" stop-color="#b91c1c" />
    </radialGradient>
    <radialGradient id="mushieCapHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#fca5a5" />
      <stop offset="100%" stop-color="#f87171" />
    </radialGradient>
    <radialGradient id="mushieArm" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#fde68a" />
      <stop offset="100%" stop-color="#f59e0b" />
    </radialGradient>
    <radialGradient id="mushieSpore" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#c084fc" />
      <stop offset="100%" stop-color="#8b5cf6" />
    </radialGradient>
  </defs>
</svg>`;

const MUSHIE_SLEEPING = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <!-- Mushroom stem -->
  <ellipse cx="100" cy="140" rx="25" ry="40" fill="url(#mushieStem)" />
  <ellipse cx="100" cy="135" rx="20" ry="35" fill="url(#mushieStemHighlight)" opacity="0.6" />
  
  <!-- Mushroom cap -->
  <path d="M 50 110 Q 50 70 100 60 Q 150 70 150 110 Z" fill="url(#mushieCap)" data-blobbi-body="true" />
  <path d="M 55 108 Q 55 75 100 65 Q 145 75 145 108 Z" fill="url(#mushieCapHighlight)" opacity="0.7" />
  
  <!-- Cap spots -->
  <circle cx="80" cy="85" r="8" fill="white" opacity="0.8" />
  <circle cx="120" cy="80" r="10" fill="white" opacity="0.8" />
  <circle cx="100" cy="95" r="6" fill="white" opacity="0.7" />
  <circle cx="130" cy="100" r="5" fill="white" opacity="0.6" />
  <circle cx="70" cy="100" r="5" fill="white" opacity="0.6" />
  
  <!-- Sleeping eyes on stem -->
  <path d="M 80 130 Q 88 133 96 130" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  <path d="M 104 130 Q 112 133 120 130" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Peaceful mouth -->
  <circle cx="100" cy="145" r="2" fill="#1f2937" />
  
  <!-- Little arms -->
  <ellipse cx="70" cy="140" rx="8" ry="12" fill="url(#mushieArm)" transform="rotate(-20 70 140)" />
  <ellipse cx="130" cy="140" rx="8" ry="12" fill="url(#mushieArm)" transform="rotate(20 130 140)" />
  
  <!-- Floating spores with gentle animation -->
  <g>
    <animateTransform attributeName="transform" type="translate" values="0,0; 1,2; 0,0" dur="5s" repeatCount="indefinite" />
    <circle cx="55" cy="120" r="2" fill="url(#mushieSpore)" opacity="0.5" />
    <circle cx="145" cy="115" r="1.5" fill="url(#mushieSpore)" opacity="0.4" />
    <circle cx="50" cy="90" r="1" fill="url(#mushieSpore)" opacity="0.4" />
    <circle cx="150" cy="95" r="2" fill="url(#mushieSpore)" opacity="0.3" />
    <circle cx="65" cy="70" r="1.5" fill="url(#mushieSpore)" opacity="0.4" />
    <circle cx="135" cy="65" r="1" fill="url(#mushieSpore)" opacity="0.5" />
  </g>

  <!-- "Zzz" sleeping -->
  <text x="150" y="60" font-size="10" fill="#666" opacity="0.8">Z</text>
  <text x="157" y="55" font-size="8" fill="#666" opacity="0.6">z</text>
  <text x="162" y="51" font-size="6" fill="#666" opacity="0.4">z</text>
  
  <defs>
    <radialGradient id="mushieStem" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#fef3c7" />
      <stop offset="30%" stop-color="#fde68a" />
      <stop offset="70%" stop-color="#fbbf24" />
      <stop offset="100%" stop-color="#f59e0b" />
    </radialGradient>
    <radialGradient id="mushieStemHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#ffffff" />
      <stop offset="100%" stop-color="rgba(255,255,255,0.3)" />
    </radialGradient>
    <radialGradient id="mushieCap" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#f87171" />
      <stop offset="30%" stop-color="#ef4444" />
      <stop offset="70%" stop-color="#dc2626" />
      <stop offset="100%" stop-color="#b91c1c" />
    </radialGradient>
    <radialGradient id="mushieCapHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#fca5a5" />
      <stop offset="100%" stop-color="#f87171" />
    </radialGradient>
    <radialGradient id="mushieArm" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#fde68a" />
      <stop offset="100%" stop-color="#f59e0b" />
    </radialGradient>
    <radialGradient id="mushieSpore" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#c084fc" />
      <stop offset="100%" stop-color="#8b5cf6" />
    </radialGradient>
  </defs>
</svg>`;

const OWLI_BASE = `<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Gradients for 3D effect -->
    <radialGradient id="owliBody3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#d6d3d1;stop-opacity:1" />
      <stop offset="40%" style="stop-color:#a8a29e;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#78716c;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="owliEar3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#a8a29e;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#57534e;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="owliEarInner" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#d97706;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="owliEyeWhite3D" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="70%" style="stop-color:#f5f5f4;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#e7e5e4;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="owliPupil3D" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#374151;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#1e293b;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="owliBeak3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
      <stop offset="50%" style="stop-color:#f59e0b;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#d97706;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="owliBeakHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#fef3c7;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#fbbf24;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="owliWing3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#a8a29e;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#57534e;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="owliWingHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#d6d3d1;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#a8a29e;stop-opacity:1" />
    </radialGradient>
  </defs>
  
  <!-- Round body -->
  <circle cx="100" cy="110" r="60" fill="url(#owliBody3D)" data-blobbi-body="true" />
  
  <!-- Triangle ears -->
  <path d="M 60 70 L 70 48 L 82 70 Z" fill="url(#owliEar3D)" />
  <path d="M 118 70 L 130 48 L 140 70 Z" fill="url(#owliEar3D)" />
  <path d="M 65 65 L 70 52 L 77 65 Z" fill="url(#owliEarInner)" />
  <path d="M 123 65 L 130 52 L 135 65 Z" fill="url(#owliEarInner)" />
  
  <!-- Eyes (white base) -->
  <circle cx="80" cy="100" r="22" fill="url(#owliEyeWhite3D)" />
  <circle cx="120" cy="100" r="22" fill="url(#owliEyeWhite3D)" />
  
  <!-- Pupils (dark circles + highlights) -->
  <circle cx="80" cy="100" r="14" fill="url(#owliPupil3D)" />
  <circle cx="120" cy="100" r="14" fill="url(#owliPupil3D)" />
  <circle cx="84" cy="96" r="5" fill="white" opacity="0.9" />
  <circle cx="124" cy="96" r="5" fill="white" opacity="0.9" />
  
  <!-- Enhanced beak -->
  <path d="M 100 112 L 94 122 L 100 128 L 106 122 Z" fill="url(#owliBeak3D)" />
  <path d="M 100 114 L 96 120 L 100 124 L 104 120 Z" fill="url(#owliBeakHighlight)" />
  
  <!-- Wing details -->
  <ellipse cx="48" cy="110" rx="16" ry="32" fill="url(#owliWing3D)" transform="rotate(-20 48 110)" />
  <ellipse cx="152" cy="110" rx="16" ry="32" fill="url(#owliWing3D)" transform="rotate(20 152 110)" />
  <ellipse cx="50" cy="108" rx="12" ry="25" fill="url(#owliWingHighlight)" transform="rotate(-20 50 108)" />
  <ellipse cx="150" cy="108" rx="12" ry="25" fill="url(#owliWingHighlight)" transform="rotate(20 150 108)" />
  
  <!-- Soft feather texture details -->
  <circle cx="70" cy="130" r="3" fill="rgba(255,255,255,0.2)" />
  <circle cx="130" cy="125" r="2.5" fill="rgba(255,255,255,0.2)" />
  <circle cx="85" cy="140" r="2" fill="rgba(255,255,255,0.15)" />
  <circle cx="115" cy="135" r="2.5" fill="rgba(255,255,255,0.15)" />
</svg>`;

const OWLI_SLEEPING = `<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Gradients for 3D effect -->
    <radialGradient id="owliBody3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#d6d3d1;stop-opacity:1" />
      <stop offset="40%" style="stop-color:#a8a29e;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#78716c;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="owliEar3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#a8a29e;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#57534e;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="owliEarInner" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#d97706;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="owliEyeWhite3D" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="70%" style="stop-color:#f5f5f4;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#e7e5e4;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="owliPupil3D" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#374151;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#1e293b;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="owliBeak3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
      <stop offset="50%" style="stop-color:#f59e0b;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#d97706;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="owliBeakHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#fef3c7;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#fbbf24;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="owliWing3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#a8a29e;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#57534e;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="owliWingHighlight" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#d6d3d1;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#a8a29e;stop-opacity:1" />
    </radialGradient>
  </defs>
  
  <!-- Round body -->
  <circle cx="100" cy="110" r="60" fill="url(#owliBody3D)" data-blobbi-body="true" />
  
  <!-- Triangle ears -->
  <path d="M 60 70 L 70 48 L 82 70 Z" fill="url(#owliEar3D)" />
  <path d="M 118 70 L 130 48 L 140 70 Z" fill="url(#owliEar3D)" />
  <path d="M 65 65 L 70 52 L 77 65 Z" fill="url(#owliEarInner)" />
  <path d="M 123 65 L 130 52 L 135 65 Z" fill="url(#owliEarInner)" />
  
  <!-- Large expressive eyes -->
  <circle cx="80" cy="100" r="22" fill="url(#owliEyeWhite3D)" />
  <circle cx="120" cy="100" r="22" fill="url(#owliEyeWhite3D)" />
  
  <!-- Sleeping eyes -->
  <path d="M 58 100 Q 80 103 102 100" stroke="#1e293b" stroke-width="3" fill="none" stroke-linecap="round" />
  <path d="M 98 100 Q 120 103 142 100" stroke="#1e293b" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Enhanced beak -->
  <path d="M 100 112 L 94 122 L 100 128 L 106 122 Z" fill="url(#owliBeak3D)" />
  <path d="M 100 114 L 96 120 L 100 124 L 104 120 Z" fill="url(#owliBeakHighlight)" />
  
  <!-- Wing details -->
  <ellipse cx="48" cy="110" rx="16" ry="32" fill="url(#owliWing3D)" transform="rotate(-20 48 110)" />
  <ellipse cx="152" cy="110" rx="16" ry="32" fill="url(#owliWing3D)" transform="rotate(20 152 110)" />
  <ellipse cx="50" cy="108" rx="12" ry="25" fill="url(#owliWingHighlight)" transform="rotate(-20 50 108)" />
  <ellipse cx="150" cy="108" rx="12" ry="25" fill="url(#owliWingHighlight)" transform="rotate(20 150 108)" />
  
  <!-- Soft feather texture details -->
  <circle cx="70" cy="130" r="3" fill="rgba(255,255,255,0.2)" />
  <circle cx="130" cy="125" r="2.5" fill="rgba(255,255,255,0.2)" />
  <circle cx="85" cy="140" r="2" fill="rgba(255,255,255,0.15)" />
  <circle cx="115" cy="135" r="2.5" fill="rgba(255,255,255,0.15)" />

  <!-- "Zzz" sleeping -->
  <text x="150" y="60" font-size="10" fill="#666" opacity="0.8">Z</text>
  <text x="157" y="55" font-size="8" fill="#666" opacity="0.6">z</text>
  <text x="162" y="51" font-size="6" fill="#666" opacity="0.4">z</text>
</svg>`;

const PANDI_BASE = `<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Gradients for 3D effect -->
    <radialGradient id="pandiEyeWhite3D" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="70%" style="stop-color:#f5f5f4;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#e7e5e4;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="pandiPupil3D" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#374151;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#1e293b;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="pandiNose3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#1f2937;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#374151;stop-opacity:1" />
    </radialGradient>
    <linearGradient id="pandiMouth3D" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" style="stop-color:#374151;stop-opacity:1" />
      <stop offset="50%" style="stop-color:#1e293b;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#374151;stop-opacity:1" />
    </linearGradient>
    <radialGradient id="pandiArm3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#1f2937;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#374151;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="pandiLeg3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#1f2937;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#374151;stop-opacity:1" />
    </radialGradient>
  </defs>
  
  <!-- Main body - perfect circle -->
  <circle cx="100" cy="120" r="55" fill="#f8fafc" stroke="#e2e8f0" stroke-width="2" data-blobbi-body="true" />
  
  <!-- Head - perfect circle -->
  <circle cx="100" cy="85" r="45" fill="#f8fafc" stroke="#e2e8f0" stroke-width="2" />
  
  <!-- Black ear patches -->
  <circle cx="70" cy="45" r="18" fill="#1f2937" data-blobbi-skip="true" />
  <circle cx="130" cy="45" r="18" fill="#1f2937" data-blobbi-skip="true" />
  
  <!-- Inner ears -->
  <circle cx="70" cy="45" r="12" fill="#374151" data-blobbi-skip="true" />
  <circle cx="130" cy="45" r="12" fill="#374151" data-blobbi-skip="true" />
  
  <!-- Eyes (black patches + white base) -->
  <circle cx="85" cy="82" r="20" fill="#1f2937" data-blobbi-skip="true" />
  <circle cx="115" cy="82" r="20" fill="#1f2937" data-blobbi-skip="true" />
  <circle cx="85" cy="82" r="12" fill="url(#pandiEyeWhite3D)" />
  <circle cx="115" cy="82" r="12" fill="url(#pandiEyeWhite3D)" />
  
  <!-- Pupils (dark circles + highlights) -->
  <circle cx="85" cy="82" r="8" fill="url(#pandiPupil3D)" />
  <circle cx="115" cy="82" r="8" fill="url(#pandiPupil3D)" />
  <circle cx="88" cy="79" r="3" fill="white" />
  <circle cx="118" cy="79" r="3" fill="white" />
  
  <!-- Nose -->
  <path d="M 100 95 L 95 105 L 105 105 Z" fill="url(#pandiNose3D)" />
  
  <!-- Mouth -->
  <path d="M 90 110 Q 100 118 110 110" stroke="url(#pandiMouth3D)" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Arms -->
  <circle cx="45" cy="120" r="15" fill="url(#pandiArm3D)" />
  <circle cx="155" cy="120" r="15" fill="url(#pandiArm3D)" />
  
  <!-- Legs -->
  <circle cx="80" cy="165" r="18" fill="url(#pandiLeg3D)" />
  <circle cx="120" cy="165" r="18" fill="url(#pandiLeg3D)" />
</svg>`;

const PANDI_SLEEPING = `<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Gradients for 3D effect -->
    <radialGradient id="pandiEyeWhite3D" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="70%" style="stop-color:#f5f5f4;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#e7e5e4;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="pandiPupil3D" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#374151;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#1e293b;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="pandiNose3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#1f2937;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#374151;stop-opacity:1" />
    </radialGradient>
    <linearGradient id="pandiMouth3D" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" style="stop-color:#374151;stop-opacity:1" />
      <stop offset="50%" style="stop-color:#1e293b;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#374151;stop-opacity:1" />
    </linearGradient>
    <radialGradient id="pandiArm3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#1f2937;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#374151;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="pandiLeg3D" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#1f2937;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#374151;stop-opacity:1" />
    </radialGradient>
  </defs>
  
  <!-- Main body - perfect circle -->
  <circle cx="100" cy="120" r="55" fill="#f8fafc" stroke="#e2e8f0" stroke-width="2" data-blobbi-body="true" />
  
  <!-- Head - perfect circle -->
  <circle cx="100" cy="85" r="45" fill="#f8fafc" stroke="#e2e8f0" stroke-width="2" />
  
  <!-- Black ear patches -->
  <circle cx="70" cy="45" r="18" fill="#1f2937" data-blobbi-skip="true" />
  <circle cx="130" cy="45" r="18" fill="#1f2937" data-blobbi-skip="true" />
  
  <!-- Inner ears -->
  <circle cx="70" cy="45" r="12" fill="#374151" data-blobbi-skip="true" />
  <circle cx="130" cy="45" r="12" fill="#374151" data-blobbi-skip="true" />
  
  <!-- Eyes -->
  <circle cx="85" cy="82" r="20" fill="#1f2937" data-blobbi-skip="true" />
  <circle cx="115" cy="82" r="20" fill="#1f2937" data-blobbi-skip="true" />
  <circle cx="85" cy="82" r="12" fill="url(#pandiEyeWhite3D)" />
  <circle cx="115" cy="82" r="12" fill="url(#pandiEyeWhite3D)" />
  <path d="M 73 85 Q 85 88 97 85" stroke="#1e293b" stroke-width="3" fill="none" stroke-linecap="round" />
  <path d="M 103 85 Q 115 88 127 85" stroke="#1e293b" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Nose -->
  <path d="M 100 95 L 95 105 L 105 105 Z" fill="url(#pandiNose3D)" />
  
  <!-- Peaceful mouth -->
  <circle cx="100" cy="110" r="2" fill="#1e293b" />
  
  <!-- Arms -->
  <circle cx="55" cy="120" r="15" fill="url(#pandiArm3D)" />
  <circle cx="145" cy="120" r="15" fill="url(#pandiArm3D)" />
  
  <!-- Legs -->
  <circle cx="80" cy="165" r="18" fill="url(#pandiLeg3D)" />
  <circle cx="120" cy="165" r="18" fill="url(#pandiLeg3D)" />

  <!-- "Zzz" sleeping -->
  <text x="150" y="60" font-size="10" fill="#666" opacity="0.8">Z</text>
  <text x="157" y="55" font-size="8" fill="#666" opacity="0.6">z</text>
  <text x="162" y="51" font-size="6" fill="#666" opacity="0.4">z</text>
</svg>`;

const ROCKY_BASE = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <!-- Bolinha 1 - sentido horário -->
  <g transform="rotate(0 100 110)">
    <circle cx="50" cy="80" r="4" fill="url(#rockyPebble)" opacity="0.8" />
    <animateTransform attributeName="transform"
      type="rotate"
      from="0 100 110"
      to="360 100 110"
      dur="5s"
      repeatCount="indefinite" />
  </g>

  <!-- Bolinha 2 - sentido anti-horário -->
  <g transform="rotate(0 100 110)">
    <circle cx="150" cy="85" r="3" fill="url(#rockyPebble)" opacity="0.6" />
    <animateTransform attributeName="transform"
      type="rotate"
      from="0 100 110"
      to="-360 100 110"
      dur="6s"
      repeatCount="indefinite" />
  </g>

  <!-- Bolinha 3 - sentido horário (mais lento) -->
  <g transform="rotate(0 100 110)">
    <circle cx="45" cy="140" r="2.5" fill="url(#rockyPebble)" opacity="0.7" />
    <animateTransform attributeName="transform"
      type="rotate"
      from="0 100 110"
      to="360 100 110"
      dur="8s"
      repeatCount="indefinite" />
  </g>

  <!-- Bolinha 4 - sentido anti-horário (mais rápido) -->
  <g transform="rotate(0 100 110)">
    <circle cx="155" cy="135" r="3.5" fill="url(#rockyPebble)" opacity="0.5" />
    <animateTransform attributeName="transform"
      type="rotate"
      from="0 100 110"
      to="-360 100 110"
      dur="4s"
      repeatCount="indefinite" />
  </g>

  <!-- Rocky's body -->
  <path d="M 100 50 L 130 70 L 140 110 L 130 150 L 100 165 L 70 150 L 60 110 L 70 70 Z" fill="url(#rockyBody)" data-blobbi-body="true" />
  <path d="M 100 55 L 125 72 L 135 108 L 125 145 L 100 158 L 75 145 L 65 108 L 75 72 Z" fill="url(#rockyInner)" opacity="0.8" />

  <!-- Texture -->
  <path d="M 75 80 L 125 85" stroke="#57534e" stroke-width="2" opacity="0.5" />
  <path d="M 70 110 L 130 115" stroke="#57534e" stroke-width="2" opacity="0.5" />
  <path d="M 80 140 L 120 135" stroke="#57534e" stroke-width="2" opacity="0.5" />

  <!-- Eyes (white base) -->
  <circle cx="85" cy="95" r="12" fill="white" />
  <circle cx="115" cy="95" r="12" fill="white" />
  
  <!-- Pupils (dark circles + highlights) -->
  <circle cx="85" cy="95" r="8" fill="#1f2937" />
  <circle cx="115" cy="95" r="8" fill="#1f2937" />
  <circle cx="88" cy="92" r="4" fill="white" />
  <circle cx="118" cy="92" r="4" fill="white" />

  <!-- Mouth -->
  <path d="M 88 115 Q 100 123 112 115" stroke="#1f2937" stroke-width="4" fill="none" stroke-linecap="round" />

  <!-- Arms -->
  <ellipse cx="55" cy="110" rx="12" ry="8" fill="url(#rockyArm)" transform="rotate(-15 55 110)" />
  <ellipse cx="145" cy="110" rx="12" ry="8" fill="url(#rockyArm)" transform="rotate(15 145 110)" />

  <!-- Legs -->
  <ellipse cx="85" cy="160" rx="15" ry="10" fill="url(#rockyLeg)" />
  <ellipse cx="115" cy="160" rx="15" ry="10" fill="url(#rockyLeg)" />

  <defs>
    <radialGradient id="rockyBody" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#a8a29e" />
      <stop offset="30%" stop-color="#78716c" />
      <stop offset="70%" stop-color="#57534e" />
      <stop offset="100%" stop-color="#44403c" />
    </radialGradient>
    <radialGradient id="rockyInner" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#d6d3d1" />
      <stop offset="100%" stop-color="#a8a29e" />
    </radialGradient>
    <radialGradient id="rockyArm" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#78716c" />
      <stop offset="100%" stop-color="#44403c" />
    </radialGradient>
    <radialGradient id="rockyLeg" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#57534e" />
      <stop offset="100%" stop-color="#292524" />
    </radialGradient>
    <radialGradient id="rockyPebble" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#a8a29e" />
      <stop offset="100%" stop-color="#57534e" />
    </radialGradient>
  </defs>
</svg>`;

const ROCKY_SLEEPING = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <!-- Sombra -->
  <ellipse cx="105" cy="185" rx="50" ry="8" fill="rgba(0,0,0,0.2)" />

  <!-- Bolinha 1 - sentido horário (mais lento) -->
  <g transform="rotate(0 100 110)">
    <circle cx="50" cy="80" r="4" fill="url(#rockyPebble)" opacity="0.5" />
    <animateTransform attributeName="transform"
                      type="rotate"
                      from="0 100 110"
                      to="360 100 110"
                      dur="10s"
                      repeatCount="indefinite" />
  </g>

  <!-- Bolinha 2 - sentido anti-horário (mais lento) -->
  <g transform="rotate(0 100 110)">
    <circle cx="150" cy="85" r="3" fill="url(#rockyPebble)" opacity="0.4" />
    <animateTransform attributeName="transform"
                      type="rotate"
                      from="0 100 110"
                      to="-360 100 110"
                      dur="12s"
                      repeatCount="indefinite" />
  </g>

  <!-- Bolinha 3 - sentido horário (mais lento) -->
  <g transform="rotate(0 100 110)">
    <circle cx="45" cy="140" r="2.5" fill="url(#rockyPebble)" opacity="0.4" />
    <animateTransform attributeName="transform"
                      type="rotate"
                      from="0 100 110"
                      to="360 100 110"
                      dur="16s"
                      repeatCount="indefinite" />
  </g>

  <!-- Bolinha 4 - sentido anti-horário (mais lento) -->
  <g transform="rotate(0 100 110)">
    <circle cx="155" cy="135" r="3.5" fill="url(#rockyPebble)" opacity="0.3" />
    <animateTransform attributeName="transform"
                      type="rotate"
                      from="0 100 110"
                      to="-360 100 110"
                      dur="8s"
                      repeatCount="indefinite" />
  </g>

  <!-- Corpo do Rocky -->
  <path d="M 100 50 L 130 70 L 140 110 L 130 150 L 100 165 L 70 150 L 60 110 L 70 70 Z" 
        fill="url(#rockyBody)" data-blobbi-body="true" />
  <path d="M 100 55 L 125 72 L 135 108 L 125 145 L 100 158 L 75 145 L 65 108 L 75 72 Z" 
        fill="url(#rockyInner)" opacity="0.8" />

  <!-- Textura -->
  <path d="M 75 80 L 125 85" stroke="#57534e" stroke-width="2" opacity="0.5" />
  <path d="M 70 110 L 130 115" stroke="#57534e" stroke-width="2" opacity="0.5" />
  <path d="M 80 140 L 120 135" stroke="#57534e" stroke-width="2" opacity="0.5" />

  <!-- Sleeping eyes -->
  <path d="M 73 95 Q 85 98 97 95" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  <path d="M 103 95 Q 115 98 127 95" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />

  <!-- Peaceful mouth -->
  <circle cx="100" cy="115" r="2" fill="#1f2937" />

  <!-- Braços -->
  <ellipse cx="55" cy="110" rx="12" ry="8" fill="url(#rockyArm)" transform="rotate(-15 55 110)" />
  <ellipse cx="145" cy="110" rx="12" ry="8" fill="url(#rockyArm)" transform="rotate(15 145 110)" />

  <!-- Pernas -->
  <ellipse cx="85" cy="160" rx="15" ry="10" fill="url(#rockyLeg)" />
  <ellipse cx="115" cy="160" rx="15" ry="10" fill="url(#rockyLeg)" />

  <!-- "Zzz" sleeping -->
  <text x="150" y="60" font-size="10" fill="#666" opacity="0.8">Z</text>
  <text x="157" y="55" font-size="8" fill="#666" opacity="0.6">z</text>
  <text x="162" y="51" font-size="6" fill="#666" opacity="0.4">z</text>

  <defs>
    <radialGradient id="rockyBody" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#a8a29e" />
      <stop offset="30%" stop-color="#78716c" />
      <stop offset="70%" stop-color="#57534e" />
      <stop offset="100%" stop-color="#44403c" />
    </radialGradient>
    <radialGradient id="rockyInner" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#d6d3d1" />
      <stop offset="100%" stop-color="#a8a29e" />
    </radialGradient>
    <radialGradient id="rockyArm" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#78716c" />
      <stop offset="100%" stop-color="#44403c" />
    </radialGradient>
    <radialGradient id="rockyLeg" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#57534e" />
      <stop offset="100%" stop-color="#292524" />
    </radialGradient>
    <radialGradient id="rockyPebble" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#a8a29e" />
      <stop offset="100%" stop-color="#57534e" />
    </radialGradient>
  </defs>
</svg>`;

const ROSEY_BASE = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">  
  <!-- Rose stem -->
  <rect x="98" y="120" width="4" height="50" fill="url(#roseyStem)" rx="2" />
  
  <!-- Thorns -->
  <path d="M 98 130 L 94 128" stroke="#15803d" stroke-width="2" stroke-linecap="round" />
  <path d="M 102 145 L 106 143" stroke="#15803d" stroke-width="2" stroke-linecap="round" />
  
  <!-- Leaves -->
  <ellipse cx="85" cy="145" rx="12" ry="8" fill="url(#roseyLeaf)" transform="rotate(-30 85 140)" />
  <ellipse cx="110" cy="150" rx="12" ry="8" fill="url(#roseyLeaf)" transform="rotate(30 115 150)" />
  
  <!-- Rose petals - layered -->
  <circle cx="100" cy="90" r="35" fill="url(#roseyPetal1)" data-blobbi-body="true" />
  <path d="M 100 60 Q 120 70 125 90 Q 120 110 100 120 Q 80 110 75 90 Q 80 70 100 60" fill="url(#roseyPetal2)" />
  <path d="M 100 65 Q 115 73 118 90 Q 115 107 100 115 Q 85 107 82 90 Q 85 73 100 65" fill="url(#roseyPetal3)" />
  <circle cx="100" cy="90" r="20" fill="url(#roseyCenter)" />
  
  <!-- Eyes (white base) -->
  <circle cx="90" cy="85" r="8" fill="white" />
  <circle cx="110" cy="85" r="8" fill="white" />
  
  <!-- Pupils (dark circles + highlights) -->
  <circle cx="90" cy="85" r="5" fill="#1f2937" />
  <circle cx="110" cy="85" r="5" fill="#1f2937" />
  <circle cx="92" cy="83" r="2" fill="white" />
  <circle cx="112" cy="83" r="2" fill="white" />
  
  <!-- Mouth -->
  <path d="M 92 100 Q 100 106 108 100" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Rosy cheeks -->
  <circle cx="75" cy="95" r="6" fill="url(#roseyBlush)" opacity="0.6" />
  <circle cx="125" cy="95" r="6" fill="url(#roseyBlush)" opacity="0.6" />
  
  <!-- Floating petals -->
  <ellipse cx="55" cy="70" rx="8" ry="5" fill="url(#roseyFloatingPetal)" opacity="0.8" transform="rotate(45 55 70)" />
  <ellipse cx="145" cy="75" rx="7" ry="4" fill="url(#roseyFloatingPetal)" opacity="0.6" transform="rotate(-30 145 75)" />
  <ellipse cx="50" cy="120" rx="6" ry="3.5" fill="url(#roseyFloatingPetal)" opacity="0.7" transform="rotate(60 50 120)" />
  <ellipse cx="150" cy="115" rx="7" ry="4" fill="url(#roseyFloatingPetal)" opacity="0.5" transform="rotate(-45 150 115)" />
  
    <!-- Rosey pot -->
  <path d="M 75 160 L 80 175 L 120 175 L 125 160 Z" fill="url(#leafyPot)" />
  <rect x="75" y="160" width="50" height="5" fill="url(#leafyPotRim)" rx="2" />

  <defs>
    <radialGradient id="roseyStem" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#22c55e" />
      <stop offset="100%" stop-color="#15803d" />
    </radialGradient>
    <radialGradient id="roseyLeaf" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#4ade80" />
      <stop offset="100%" stop-color="#16a34a" />
    </radialGradient>
    <radialGradient id="roseyPetal1" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#fce7f3" />
      <stop offset="30%" stop-color="#f9a8d4" />
      <stop offset="70%" stop-color="#f472b6" />
      <stop offset="100%" stop-color="#ec4899" />
    </radialGradient>
    <radialGradient id="roseyPetal2" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#fbcfe8" />
      <stop offset="100%" stop-color="#f472b6" />
    </radialGradient>
    <radialGradient id="roseyPetal3" cx="0.5" cy="0.4">
      <stop offset="0%" stop-color="#fce7f3" />
      <stop offset="100%" stop-color="#f9a8d4" />
    </radialGradient>
    <radialGradient id="roseyCenter" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#f9a8d4" />
      <stop offset="100%" stop-color="#ec4899" />
    </radialGradient>
    <radialGradient id="roseyBlush" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#fce7f3" />
      <stop offset="100%" stop-color="#f472b6" />
    </radialGradient>
    <radialGradient id="roseyArm" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#f9a8d4" />
      <stop offset="100%" stop-color="#ec4899" />
    </radialGradient>
    <radialGradient id="roseyFloatingPetal" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#fbcfe8" />
      <stop offset="100%" stop-color="#f472b6" />
    </radialGradient>
    <radialGradient id="leafyPot" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#dc2626" />
      <stop offset="100%" stop-color="#991b1b" />
    </radialGradient>
    <radialGradient id="leafyPotRim" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#ef4444" />
      <stop offset="100%" stop-color="#dc2626" />
    </radialGradient>
  </defs>
</svg>`;

const ROSEY_SLEEPING = `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">  
  <!-- Rose stem -->
  <rect x="98" y="120" width="4" height="50" fill="url(#roseyStem)" rx="2" />
  
  <!-- Thorns -->
  <path d="M 98 130 L 94 128" stroke="#15803d" stroke-width="2" stroke-linecap="round" />
  <path d="M 102 145 L 106 143" stroke="#15803d" stroke-width="2" stroke-linecap="round" />
  
  <!-- Leaves -->
  <ellipse cx="85" cy="140" rx="12" ry="8" fill="url(#roseyLeaf)" transform="rotate(-30 85 140)" />
  <ellipse cx="115" cy="150" rx="12" ry="8" fill="url(#roseyLeaf)" transform="rotate(30 115 150)" />
  
  <!-- Rose petals - layered -->
  <circle cx="100" cy="90" r="35" fill="url(#roseyPetal1)" data-blobbi-body="true" />
  <path d="M 100 60 Q 120 70 125 90 Q 120 110 100 120 Q 80 110 75 90 Q 80 70 100 60" fill="url(#roseyPetal2)" />
  <path d="M 100 65 Q 115 73 118 90 Q 115 107 100 115 Q 85 107 82 90 Q 85 73 100 65" fill="url(#roseyPetal3)" />
  <circle cx="100" cy="90" r="20" fill="url(#roseyCenter)" />
  
  <!-- Sleeping eyes -->
  <path d="M 82 85 Q 90 88 98 85" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  <path d="M 102 85 Q 110 88 118 85" stroke="#1f2937" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Peaceful mouth -->
  <circle cx="100" cy="100" r="2" fill="#1f2937" />
  
  <!-- Rosy cheeks -->
  <circle cx="75" cy="95" r="6" fill="url(#roseyBlush)" opacity="0.6" />
  <circle cx="125" cy="95" r="6" fill="url(#roseyBlush)" opacity="0.6" />
  
  <!-- Little arms from center -->
  <ellipse cx="70" cy="90" rx="8" ry="12" fill="url(#roseyArm)" transform="rotate(-30 70 90)" />
  <ellipse cx="130" cy="90" rx="8" ry="12" fill="url(#roseyArm)" transform="rotate(30 130 90)" />
  
  <!-- Floating petals with gentle animation -->
  <g>
    <animateTransform attributeName="transform" type="translate" values="0,0; 2,3; 0,0" dur="6s" repeatCount="indefinite" />
    <ellipse cx="55" cy="70" rx="8" ry="5" fill="url(#roseyFloatingPetal)" opacity="0.5" transform="rotate(45 55 70)" />
    <ellipse cx="145" cy="75" rx="7" ry="4" fill="url(#roseyFloatingPetal)" opacity="0.4" transform="rotate(-30 145 75)" />
    <ellipse cx="50" cy="120" rx="6" ry="3.5" fill="url(#roseyFloatingPetal)" opacity="0.4" transform="rotate(60 50 120)" />
    <ellipse cx="150" cy="115" rx="7" ry="4" fill="url(#roseyFloatingPetal)" opacity="0.3" transform="rotate(-45 150 115)" />
  </g>

  <!-- "Zzz" sleeping -->
  <text x="150" y="60" font-size="10" fill="#666" opacity="0.8">Z</text>
  <text x="157" y="55" font-size="8" fill="#666" opacity="0.6">z</text>
  <text x="162" y="51" font-size="6" fill="#666" opacity="0.4">z</text>
  
  <defs>
    <radialGradient id="roseyStem" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#22c55e" />
      <stop offset="100%" stop-color="#15803d" />
    </radialGradient>
    <radialGradient id="roseyLeaf" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#4ade80" />
      <stop offset="100%" stop-color="#16a34a" />
    </radialGradient>
    <radialGradient id="roseyPetal1" cx="0.3" cy="0.2">
      <stop offset="0%" stop-color="#fce7f3" />
      <stop offset="30%" stop-color="#f9a8d4" />
      <stop offset="70%" stop-color="#f472b6" />
      <stop offset="100%" stop-color="#ec4899" />
    </radialGradient>
    <radialGradient id="roseyPetal2" cx="0.4" cy="0.3">
      <stop offset="0%" stop-color="#fbcfe8" />
      <stop offset="100%" stop-color="#f472b6" />
    </radialGradient>
    <radialGradient id="roseyPetal3" cx="0.5" cy="0.4">
      <stop offset="0%" stop-color="#fce7f3" />
      <stop offset="100%" stop-color="#f9a8d4" />
    </radialGradient>
    <radialGradient id="roseyCenter" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#f9a8d4" />
      <stop offset="100%" stop-color="#ec4899" />
    </radialGradient>
    <radialGradient id="roseyBlush" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#fce7f3" />
      <stop offset="100%" stop-color="#f472b6" />
    </radialGradient>
    <radialGradient id="roseyArm" cx="0.3" cy="0.3">
      <stop offset="0%" stop-color="#f9a8d4" />
      <stop offset="100%" stop-color="#ec4899" />
    </radialGradient>
    <radialGradient id="roseyFloatingPetal" cx="0.5" cy="0.5">
      <stop offset="0%" stop-color="#fbcfe8" />
      <stop offset="100%" stop-color="#f472b6" />
    </radialGradient>
  </defs>
</svg>`;

const STARRI_BASE = `<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Star gradients -->
    <radialGradient id="starriBody" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#4c1d95;stop-opacity:1" />
      <stop offset="30%" style="stop-color:#3730a3;stop-opacity:1" />
      <stop offset="70%" style="stop-color:#1e1b4b;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#0f172a;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="starriInner" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
      <stop offset="50%" style="stop-color:#f59e0b;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#d97706;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="starriEye" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#e0e7ff;stop-opacity:1" />
    </radialGradient>
    <linearGradient id="starriSmile" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
      <stop offset="50%" style="stop-color:#f59e0b;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#fbbf24;stop-opacity:1" />
    </linearGradient>
    <radialGradient id="starriDust1" cx="0.5" cy="0.5">
      <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#f59e0b;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="starriDust2" cx="0.5" cy="0.5">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#e0e7ff;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="starriDust3" cx="0.5" cy="0.5">
      <stop offset="0%" style="stop-color:#c084fc;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#8b5cf6;stop-opacity:1" />
    </radialGradient>
    <linearGradient id="starriConstellation" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#c084fc;stop-opacity:1" />
    </linearGradient>
  </defs>
  
  <!-- Main star body - larger 5-pointed star shape -->
  <path d="M 100 25 L 115 75 L 165 75 L 125 110 L 140 160 L 100 130 L 60 160 L 75 110 L 35 75 L 85 75 Z" fill="url(#starriBody)" data-blobbi-body="true" />
  <path d="M 100 35 L 112 70 L 150 70 L 120 95 L 132 135 L 100 115 L 68 135 L 80 95 L 50 70 L 88 70 Z" fill="url(#starriInner)" opacity="0.8" />
  
  <!-- Eyes (white base) -->
  <circle cx="88" cy="95" r="10" fill="url(#starriEye)" />
  <circle cx="112" cy="95" r="10" fill="url(#starriEye)" />
  
  <!-- Pupils (dark circles + highlights) -->
  <circle cx="88" cy="95" r="6" fill="#1e1b4b" />
  <circle cx="112" cy="95" r="6" fill="#1e1b4b" />
  <circle cx="90" cy="93" r="3" fill="white" />
  <circle cx="114" cy="93" r="3" fill="white" />
  
  <!-- Mouth -->
  <path d="M 88 115 Q 100 125 112 115" stroke="url(#starriSmile)" stroke-width="4" fill="none" stroke-linecap="round" />
  
  <!-- Floating stardust -->
  <circle cx="55" cy="60" r="2" fill="url(#starriDust1)" opacity="0.9" />
  <circle cx="145" cy="65" r="1.5" fill="url(#starriDust2)" opacity="0.8" />
  <circle cx="60" cy="140" r="2.5" fill="url(#starriDust3)" opacity="0.7" />
  <circle cx="140" cy="135" r="2" fill="url(#starriDust1)" opacity="0.6" />
  <circle cx="40" cy="100" r="1.5" fill="url(#starriDust2)" opacity="0.8" />
  <circle cx="160" cy="105" r="2" fill="url(#starriDust3)" opacity="0.9" />
  
  <!-- Constellation lines -->
  <path d="M 55 60 L 70 45 L 130 50 L 145 65" stroke="url(#starriConstellation)" stroke-width="1.5" opacity="0.5" />
  <path d="M 40 100 L 60 140 L 140 135 L 160 105" stroke="url(#starriConstellation)" stroke-width="1.5" opacity="0.5" />
</svg>`;

const STARRI_SLEEPING = `<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Star gradients -->
    <radialGradient id="starriBody" cx="0.3" cy="0.2">
      <stop offset="0%" style="stop-color:#4c1d95;stop-opacity:1" />
      <stop offset="30%" style="stop-color:#3730a3;stop-opacity:1" />
      <stop offset="70%" style="stop-color:#1e1b4b;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#0f172a;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="starriInner" cx="0.4" cy="0.3">
      <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
      <stop offset="50%" style="stop-color:#f59e0b;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#d97706;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="starriEye" cx="0.3" cy="0.3">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#e0e7ff;stop-opacity:1" />
    </radialGradient>
    <linearGradient id="starriSmile" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
      <stop offset="50%" style="stop-color:#f59e0b;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#fbbf24;stop-opacity:1" />
    </linearGradient>
    <radialGradient id="starriDust1" cx="0.5" cy="0.5">
      <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#f59e0b;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="starriDust2" cx="0.5" cy="0.5">
      <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#e0e7ff;stop-opacity:1" />
    </radialGradient>
    <radialGradient id="starriDust3" cx="0.5" cy="0.5">
      <stop offset="0%" style="stop-color:#c084fc;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#8b5cf6;stop-opacity:1" />
    </radialGradient>
    <linearGradient id="starriConstellation" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#c084fc;stop-opacity:1" />
    </linearGradient>
  </defs>
  
  <!-- Main star body - larger 5-pointed star shape -->
  <path d="M 100 25 L 115 75 L 165 75 L 125 110 L 140 160 L 100 130 L 60 160 L 75 110 L 35 75 L 85 75 Z" 
        fill="url(#starriBody)" data-blobbi-body="true" />
  <path d="M 100 35 L 112 70 L 150 70 L 120 95 L 132 135 L 100 115 L 68 135 L 80 95 L 50 70 L 88 70 Z" 
        fill="url(#starriInner)" opacity="0.8" />
  
  <!-- Twinkling eyes -->
  <circle cx="88" cy="95" r="10" fill="url(#starriEye)" />
  <circle cx="112" cy="95" r="10" fill="url(#starriEye)" />
  
  <!-- Sleeping eyes -->
  <path d="M 78 95 Q 88 98 98 95" stroke="#1e1b4b" stroke-width="3" fill="none" stroke-linecap="round" />
  <path d="M 102 95 Q 112 98 122 95" stroke="#1e1b4b" stroke-width="3" fill="none" stroke-linecap="round" />
  
  <!-- Peaceful mouth -->
  <circle cx="100" cy="115" r="2" fill="#f59e0b" />
  
  <!-- Floating stardust with gentle animation -->
  <g>
    <animateTransform attributeName="transform" type="translate" values="0,0; 1,2; 0,0" dur="4s" repeatCount="indefinite" />
    <circle cx="55" cy="60" r="2" fill="url(#starriDust1)" opacity="0.6" />
    <circle cx="145" cy="65" r="1.5" fill="url(#starriDust2)" opacity="0.5" />
    <circle cx="60" cy="140" r="2.5" fill="url(#starriDust3)" opacity="0.4" />
    <circle cx="140" cy="135" r="2" fill="url(#starriDust1)" opacity="0.4" />
    <circle cx="40" cy="100" r="1.5" fill="url(#starriDust2)" opacity="0.5" />
    <circle cx="160" cy="105" r="2" fill="url(#starriDust3)" opacity="0.6" />
  </g>
  
  <!-- Constellation lines -->
  <path d="M 55 60 L 70 45 L 130 50 L 145 65" stroke="url(#starriConstellation)" stroke-width="1.5" opacity="0.3" />
  <path d="M 40 100 L 60 140 L 140 135 L 160 105" stroke="url(#starriConstellation)" stroke-width="1.5" opacity="0.3" />

  <!-- "Zzz" sleeping -->
  <text x="150" y="60" font-size="10" fill="#666" opacity="0.8">Z</text>
  <text x="157" y="55" font-size="8" fill="#666" opacity="0.6">z</text>
  <text x="162" y="51" font-size="6" fill="#666" opacity="0.4">z</text>
</svg>`;

/**
 * Map of adult form to { base, sleeping } SVG content
 */
export const ADULT_SVG_MAP: Record<AdultForm, { base: string; sleeping: string }> = {
  bloomi: { base: BLOOMI_BASE, sleeping: BLOOMI_SLEEPING },
  breezy: { base: BREEZY_BASE, sleeping: BREEZY_SLEEPING },
  cacti: { base: CACTI_BASE, sleeping: CACTI_SLEEPING },
  catti: { base: CATTI_BASE, sleeping: CATTI_SLEEPING },
  cloudi: { base: CLOUDI_BASE, sleeping: CLOUDI_SLEEPING },
  crysti: { base: CRYSTI_BASE, sleeping: CRYSTI_SLEEPING },
  droppi: { base: DROPPI_BASE, sleeping: DROPPI_SLEEPING },
  flammi: { base: FLAMMI_BASE, sleeping: FLAMMI_SLEEPING },
  froggi: { base: FROGGI_BASE, sleeping: FROGGI_SLEEPING },
  leafy: { base: LEAFY_BASE, sleeping: LEAFY_SLEEPING },
  mushie: { base: MUSHIE_BASE, sleeping: MUSHIE_SLEEPING },
  owli: { base: OWLI_BASE, sleeping: OWLI_SLEEPING },
  pandi: { base: PANDI_BASE, sleeping: PANDI_SLEEPING },
  rocky: { base: ROCKY_BASE, sleeping: ROCKY_SLEEPING },
  rosey: { base: ROSEY_BASE, sleeping: ROSEY_SLEEPING },
  starri: { base: STARRI_BASE, sleeping: STARRI_SLEEPING },
};
